import { DynamicFormsDataService } from './shared/dynamic-forms-data.service';
import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  ViewChild,
  QueryList,
  ViewChildren,
  ChangeDetectorRef,
  ViewRef,
  OnDestroy,
  TemplateRef
} from '@angular/core';
import { result, find, findIndex, filter } from 'lodash';
import {
  Context,
  TaskEvent,
  Tarea,
  DynamicComponentForm,
  Forma,
  ConfigFinishDefault,
  Control,
  Datos,
  Static,
  Documento,
  FuncionDocumento,
  DocumentoDetalle,
  HistorialDocumento,
  RevisionDocumento,
  Const,
  ConfirmComponent,
  InformacionGuardadaFormulario,
  DatosSincronizacionFormulario,
  SincronizacionFormulario,
  TareaSincronizada,
  CamposSincronizar,
  DatosSincronizacion,
  CondicionDocumento,
  SubForma,
  TablaDatos,
  DatesCondiction,
  TareaCondicion,
  OrdenPestanas,
  DocumentoGenerado,
  SolicitanteControl,
  SolicitanteValidacionControl
} from '@app/shared';
import { ToastrService } from 'ngx-toastr';
import { ScrollToConfigOptions, ScrollToService } from '@nicky-lenaers/ngx-scroll-to';
import { UpdateTable, SaveTables } from '@app/shared/refactor-dynamic-form/refactor-dynamic-form.component';
import { RadicationDocsComponent } from '@app/forms/shared/radication-docs/radication-docs.component';
import { ApproveSignComponent } from '@app/forms/shared/approve-sign/approve-sign.component';
import { DocsComponent } from '@app/forms/shared/docs/docs.component';
import { TabsetComponent } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { environment } from '@env/environment';
import { LocalDataSource } from 'ng2-smart-table';
import { DynamicFormsConfig } from './shared/dynamic-forms-data.config.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { HistoryAssignment } from '@app/forms';

interface OrderTabsView extends OrdenPestanas {
  view: boolean;
  complete?: boolean;
}

const radicacion_cinco = environment.radicacion_cinco;

@Component({
  selector: 'iw-dynamic-forms',
  templateUrl: './dynamic-forms.component.html',
  styleUrls: ['./dynamic-forms.component.scss'],
  providers: [DynamicFormsDataService]
})
export class DynamicFormsComponent extends DynamicComponentForm implements OnInit, OnDestroy {

  // Contexto del formulario, es suministrado dinámicamente
  @Input() ctx: Context;
  // Evento para finalizar y cerrar la modal, es suministrado dinámicamente
  @Input() event: EventEmitter<TaskEvent>;
  // Define cuando realizar el auto guardado de la tarea
  @Input() autoSave = false;
  // Define cuando activar la previsualizacion de informacion de flujo
  @Input() previewFlow = false;
  private eventsSubjectForm: Subject<any> = new Subject<any>();
  private eventsSubjectTable: Subject<any> = new Subject<any>();
  // Tipo del proceso de la tarea renderizada
  typeProcess: string;
  // Define el mensaje a mostrar en la ventana del cargando
  message = '';
  // Id de la forma que contiene el campo de associacion de Tramite
  idFormAssociation = 0;
  // id del tramite a asociar
  idTramiteAsociar = 0;
  // indica si se asocian documentos o no
  documentAsociar = false;
  // Define cuando abre la ventana de gestion de documentos
  wimdowManagementDocs = false;
  // Activa el componente de refactorizar la forma
  activeForm = false;
  // Activa el boton de finalizar la tarea
  isDisabledBtnFinish = true;
  formValid = false;
  docsValid = false;
  radicateCompleted = false;
  revisionCompleted = false;
  specialradicateCompleted = false;
  remissionFuntionaries = false;
  copyTo = false;
  sentBy = false;
  responseOf = false;
  //define el ícono de check para la radicacion especial
  specialFinished = false;
  // define el icono check para la pestaña en respuesta de 
  finishedResponseOf = false;
  //define el icono check de la pestaña remision de funcionarios
  remissionFinished = false;
  //define el icono check de la pestaña enviado por 
  sendedByFinished = false;
  //define el icono check de la pestaña copia a 
  copyToFinished = false;
  // Define cuando se debe ocultar el componente de refactorizacion de formas y mostrar el componente de carga de accion
  viewDynamicForm = true;
  // Mostrar cargando de acciones
  loadAction = false;
  // Define la finaliacioncion de la tarea
  finishTask = false;
  // Define si hay una secundaria iniciada
  secondaryActive = false;
  // Determina si el usuario en sesion es responsable de la tarea
  userResponsible = false;
  // Define cuando muestra o oculta el tab de revisiones
  tabRevisions = false;
  // Define cuando muestra o culta el tab de gestionar documentos
  tabDocs = false;
  // Define cuando muestra o culta el tab de radicar
  tabRadicate = false;
  // Define cuando muestra o culta el tab de anexos
  tabAttached = false;
  // Define cuando muestra o culta el tab de radicación especial
  tabSpecial = false;
  // Define cuando muestra o culta el tab de remisión
  tabRemission = false;
  // Define cuando muestra o oculta el tab de endivado por
  tabSendedBy = false;
  // Define cuando muestra o culta el tab de con copia a 
  tabCopy = false;
  // Define cuando muestra o culta el tab de En Respuesta De
  tabResponse = false;
  // Define cuando debe realizar la asociacion de procesos
  associateTramite = false;
  // Define cuando ejecutar las condiciones de documentos y radicación inicialmente
  runCondictionsDoc = false;
  // Define cuando se esta guardando un formulario
  savingForm = false;
  // Diferentes opciones de aprovacion
  optionsPositive: Array<string> = [
    'sí', 'si'
  ];
  // Contiene el orden de las pestañas
  orderTabs: OrderTabsView[] = [
    {
      orden: 1,
      pestana: 'revisiones',
      requerido: false,
      nombre: 'Aprobar / Firmar documentos',
      view: false,
      modificable: false,
      complete: false
    },
    {
      orden: 2,
      pestana: 'formularios',
      requerido: false,
      nombre: 'Formularios',
      view: false,
      modificable: true,
      complete: false
    },
    {
      orden: 3,
      pestana: 'gestion_documentos',
      requerido: false,
      nombre: 'Generar / Subir documentos',
      view: false,
      modificable: false,
      complete: false
    },
    {
      orden: 4,
      pestana: 'radicacion',
      requerido: false,
      nombre: 'Radicar / Asociar documentos',
      view: false,
      modificable: false,
      complete: false
    },
    {
      orden: 5,
      pestana: 'anexos',
      requerido: false,
      nombre: 'Anexos',
      view: false,
      modificable: false,
      complete: false
    },
    {
      orden: 6,
      pestana: 'radicacion_especial',
      requerido: false,
      nombre: 'Radicación especial',
      view: false,
      modificable: false,
      complete: false
    },
    {
      orden: 7,
      pestana: 'remision_funcionarios',
      requerido: false,
      nombre: 'Remisión',
      view: false,
      modificable: false,
      complete: false
    },
    {
      orden: 8,
      pestana: 'enviado_por',
      requerido: false,
      nombre: 'Envido por',
      view: false,
      modificable: false,
      complete: false
    },
    {
      orden: 9,
      pestana: 'con_copia_a',
      requerido: false,
      nombre: 'Copia a',
      view: false,
      modificable: false,
      complete: false
    },
    {
      orden: 10,
      pestana: 'en_respuesta_de',
      requerido: false,
      nombre: 'En respuesta de',
      view: false,
      modificable: false,
      complete: false
    },
  ];
  // id opcion del Sí
  idOptionAffirmative: number[] = [];
  // id opcion del No
  idOptionNegative: number[] = [];
  // Condiciones de acciones de los documentos en la tarea
  condictionsDocs: CondicionDocumento[] = [];
  condictionsRadicate: CondicionDocumento[] = [];
  condictionsGenerate: CondicionDocumento[] = [];
  // forma de las tareas asociadas con los campos sincronizados
  formAssociationSync: TareaSincronizada[] = [];
  // Consectivos de actas seleccionados
  consecutivesActas = {};
  // Tarea actual
  task: Tarea;
  // forma de la tarea
  form: Forma;
  // Control de associacion de tramite
  controlAssociation: Control;
  // Contiene las validaciones por documento
  condictionsDoc = {};
  // contiene los solicitantes multiples
  userMulti: Array<SolicitanteControl> = [];
  // contiene los solicitantes multiples por documento
  userMultiDoc: Array<SolicitanteValidacionControl> = [];
  // habilita el boton de historial de rechazos
  btnHistoryReject = false;
  // contiene la configuracion de la tabla de historial de rechazos
  settingsRejectHistory = {};
  // contiene los datos de la tabla de historial de rechazos
  sourceRejectHistory: LocalDataSource;

  // Contiene los datos de todas las tablas inplicadas contando las tareas asociadas
  private _dataTableAll: TablaDatos[] = [];
  // Documentos descargados
  private _documentsDownload: any[] = [];
  // Documentos generados
  private _documentsGenerated: DocumentoGenerado[] = [];
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia al componente de confirmación
  @ViewChild('confirmFinish') private confirmFinish: ConfirmComponent;
  // Modal de historial de asignaciones
  @ViewChild('templateHistoryReject') private templateHistoryReject: TemplateRef<any>;
  // Componentes de tipo radicacion
  @ViewChildren(RadicationDocsComponent) radication: QueryList<RadicationDocsComponent>;
  // Componentes de tipo aprobar y firmar
  @ViewChildren(ApproveSignComponent) approveSign: QueryList<ApproveSignComponent>;
  // Componentes de tipo documentos
  @ViewChildren(DocsComponent) docs: QueryList<DocsComponent>;
  // Contiene el tab de pestañas de la tarea_asociacion
  @ViewChildren(TabsetComponent) staticTabs: QueryList<TabsetComponent>;

  // Referencia de la modal
  modalRef: BsModalRef;


  constructor(
    private dfds: DynamicFormsDataService,
    private toastr: ToastrService,
    private sts: ScrollToService,
    private cdRef: ChangeDetectorRef,
    private modalService: BsModalService,
  ) {
    super();
  }

  async ngOnInit() {
    this.loadAction = true;
    this.message = 'Cargando pestañas';
    this.task = this.ctx.task;
    this.typeProcess = this.ctx.typeProcess;
    if (
      this.task &&
      this.task.tarea_estado &&
      this.task.tarea_estado.nombre === Const.STATUS_TASK.finished
    ) {
      this.finishTask = true;
    }
    if (
      this.task &&
      this.task.tarea_estado &&
      this.task.tarea_estado.nombre === Const.STATUS_TASK.secondaryProgress
    ) {
      this.secondaryActive = true;
    }
    if (!this.task.datos) {
      this.task.datos = [];
    }
    if (radicacion_cinco) {
      this.dfds.getForm(this.task.id).subscribe(res => {
        if (this.task.tarea_forma[0].lista_chequeo) {
          if (this.task.tarea_forma[0].opciones && Object.keys(this.task.tarea_forma[0].opciones).length) {
            Object.keys(this.task.tarea_forma[0].opciones).forEach(key => {
              const index = findIndex(res.sub_formas, { alias: key });
              if (index !== -1) {
                res.sub_formas[index].estilo['registros_especificos'] = this.task.tarea_forma[0].opciones[key];
              }
            });
          }
        }
        this.form = res;
        this.tabAttached = this.form.estilo['anexos'];
        this.tabRevisions = this.form.estilo['revisiones'] ? true : false;
        this.tabSpecial = this.form.estilo['special_radication'];
        this.tabRemission = this.form.estilo['remision'];
        this.tabCopy = this.form.estilo['funcionarios'];
        this.tabResponse = this.form.estilo['en_respuesta_de'];
        this.tabSendedBy = this.form.estilo['enviado_por'];
        this.tabDocs = this.form.documento;
        this.tabRadicate = this.form.radicado;
        if (!this.form.documento) {
          this.docsValid = true;
        }
        if (!this.form.radicado) {
          this.radicateCompleted = true;
        }
        if (this.form.estilo['condiciones_documentos'] && this.form.estilo['condiciones_documentos'].length) {
          this.form.estilo['condiciones_documentos'].forEach((condictionDoc: CondicionDocumento) => {
            if (!condictionDoc.formaDocumento) {
              switch (condictionDoc.accionDocumento) {
                case 'radicar':
                  this.condictionsRadicate.push(condictionDoc);
                  break;
                case 'generar':
                  this.condictionsGenerate.push(condictionDoc);
                  break;
                default:
                  this.condictionsDocs.push(condictionDoc);
                  break;
              }
            } else {
              if (!this.condictionsDoc.hasOwnProperty(condictionDoc.formaDocumento)) {
                this.condictionsDoc[condictionDoc.formaDocumento] = {};
              }
              if (!this.condictionsDoc[condictionDoc.formaDocumento].hasOwnProperty(condictionDoc['documento_nombre'])) {
                this.condictionsDoc[condictionDoc.formaDocumento][condictionDoc['documento_nombre']] = {
                  condictionsDocs: [],
                  condictionsRadicate: [],
                  condictionsGenerate: [],
                };
              }
              switch (condictionDoc.accionDocumento) {
                case 'radicar':
                  // tslint:disable-next-line:max-line-length
                  this.condictionsDoc[condictionDoc.formaDocumento][condictionDoc['documento_nombre']].condictionsRadicate.push(condictionDoc);
                  break;
                case 'generar':
                  // tslint:disable-next-line:max-line-length
                  this.condictionsDoc[condictionDoc.formaDocumento][condictionDoc['documento_nombre']].condictionsGenerate.push(condictionDoc);
                  break;
                default:
                  // tslint:disable-next-line:max-line-length
                  this.condictionsDoc[condictionDoc.formaDocumento][condictionDoc['documento_nombre']].condictionsDocs.push(condictionDoc);
                  break;
              }
            }
          });
        }
        this.setOrderTabs();
        this.activeForm = true;
        if (this.tabDocs) {
          this.validDocs();
          this.validCondictionsDocs();
        } else {
          this.docsValid = true;
        }
        if (this.tabRadicate) {
          this.validRadicationsDocs();
        } else {
          this.radicateCompleted = true;
        }
        if (this.tabRevisions) {
          this.validReview();
        } else {
          this.revisionCompleted = true;
        }
        if (this.tabSpecial) {
          this.validSpecial();
        } else {
          this.specialradicateCompleted = true;
        }
        if (this.tabResponse) {
          this.validResponse();
        } else {
          this.responseOf = true;
        }
        if (this.tabRemission) {
          this.validRemission();
        } else {
          this.remissionFuntionaries = true;
        }
        if (this.tabCopy) {
          this.validCopy();
        } else {
          this.copyTo = true;
        }
        if (this.tabSendedBy) {
          this.validSentBy();
        } else {
          this.sentBy = true;
        }
        if (!this.tabDocs && !this.tabRevisions) {
          this.validTask();
        }
        this.validAssociationRadication();
        this.loadConsecutives();
        this.optionCondition();
      });
    } else {
      this.dfds.getForm(this.task.tarea_forma[0].id_forma).subscribe(res => {
        if (this.task.tarea_forma[0].lista_chequeo) {
          if (this.task.tarea_forma[0].opciones && Object.keys(this.task.tarea_forma[0].opciones).length) {
            Object.keys(this.task.tarea_forma[0].opciones).forEach(key => {
              const index = findIndex(res.sub_formas, { alias: key });
              if (index !== -1) {
                res.sub_formas[index].estilo['registros_especificos'] = this.task.tarea_forma[0].opciones[key];
              }
            });
          }
        }
        this.form = res;
        this.tabAttached = this.form.estilo['anexos'];
        this.tabRevisions = this.form.estilo['revisiones'] ? true : false;
        this.tabSpecial = this.form.estilo['special_radication'];
        this.tabRemission = this.form.estilo['remision'];
        this.tabCopy = this.form.estilo['funcionarios'];
        this.tabResponse = this.form.estilo['en_respuesta_de'];
        this.tabSendedBy = this.form.estilo['enviado_por'];
        this.tabDocs = this.form.documento;
        this.tabRadicate = this.form.radicado;
        if (!this.form.documento) {
          this.docsValid = true;
        }
        if (!this.form.radicado) {
          this.radicateCompleted = true;
        }
        if (this.form.estilo['condiciones_documentos'] && this.form.estilo['condiciones_documentos'].length) {
          this.form.estilo['condiciones_documentos'].forEach((condictionDoc: CondicionDocumento) => {
            if (!condictionDoc.formaDocumento) {
              switch (condictionDoc.accionDocumento) {
                case 'radicar':
                  this.condictionsRadicate.push(condictionDoc);
                  break;
                case 'generar':
                  this.condictionsGenerate.push(condictionDoc);
                  break;
                default:
                  this.condictionsDocs.push(condictionDoc);
                  break;
              }
            } else {
              if (!this.condictionsDoc.hasOwnProperty(condictionDoc.formaDocumento)) {
                this.condictionsDoc[condictionDoc.formaDocumento] = {};
              }
              if (!this.condictionsDoc[condictionDoc.formaDocumento].hasOwnProperty(condictionDoc['documento_nombre'])) {
                this.condictionsDoc[condictionDoc.formaDocumento][condictionDoc['documento_nombre']] = {
                  condictionsDocs: [],
                  condictionsRadicate: [],
                  condictionsGenerate: [],
                };
              }
              switch (condictionDoc.accionDocumento) {
                case 'radicar':
                  // tslint:disable-next-line:max-line-length
                  this.condictionsDoc[condictionDoc.formaDocumento][condictionDoc['documento_nombre']].condictionsRadicate.push(condictionDoc);
                  break;
                case 'generar':
                  // tslint:disable-next-line:max-line-length
                  this.condictionsDoc[condictionDoc.formaDocumento][condictionDoc['documento_nombre']].condictionsGenerate.push(condictionDoc);
                  break;
                default:
                  // tslint:disable-next-line:max-line-length
                  this.condictionsDoc[condictionDoc.formaDocumento][condictionDoc['documento_nombre']].condictionsDocs.push(condictionDoc);
                  break;
              }
            }
          });
        }
        this.setOrderTabs();
        this.activeForm = true;
        if (this.tabDocs) {
          this.validDocs();
          this.validCondictionsDocs();
        } else {
          this.docsValid = true;
        }
        if (this.tabRadicate) {
          this.validRadicationsDocs();
        } else {
          this.radicateCompleted = true;
        }
        if (this.tabRevisions) {
          this.validReview();
        } else {
          this.revisionCompleted = true;
        }
        if (this.tabSpecial) {
          this.validSpecial();
        } else {
          this.specialradicateCompleted = true;
        }
        if (this.tabResponse) {
          this.validResponse();
        } else {
          this.responseOf = true;
        }
        if (this.tabRemission) {
          this.validRemission();
        } else {
          this.remissionFuntionaries = true;
        }
        if (this.tabCopy) {
          this.validCopy();
        } else {
          this.copyTo = true;
        }
        if (this.tabSendedBy) {
          this.validSentBy();
        } else {
          this.sentBy = true;
        }
        if (!this.tabDocs && !this.tabRevisions) {
          this.validTask();
        }
        this.validAssociationRadication();
        this.loadConsecutives();
        this.optionCondition();
      });
    }
    // Consulta las formas con sus campos sincronizados de las tareas asociadas a la tarea actual
    await this.dfds.getFormTaskSync(this.task.id).then(tasks => {
      this.formAssociationSync = tasks;
    }).catch(err => {
      this.formAssociationSync = [];
    });
    this.eventsSubjectForm.next();
    this.eventsSubjectTable.next();
    const configTable = new DynamicFormsConfig();
    this.settingsRejectHistory = configTable.getSettingsTableRejects();
    if (this.task.tarea_forma[0].estilo['special_radication'] === true && this.task.historial_rechazo && this.task.historial_rechazo.length) {
      this.btnHistoryReject = true;
    }
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  set documentsDownload(docs: any[]) {
    this._documentsDownload = docs;
    this.validDocs();
  }

  get documentsDownload(): any[] {
    return this._documentsDownload;
  }

  set documentsGenerated(docs: DocumentoGenerado[]) {
    this._documentsGenerated = docs;
    this.validDocs();
  }

  get documentsGenerated(): DocumentoGenerado[] {
    return this._documentsGenerated;
  }

  /**
   * Mantiene las pestañas principoales con las pestañas del contenedor fijo sincronizadas
   *
   * @param {number} tabId
   * @param {boolean} [staticTab=true]
   * @memberof DynamicFormsComponent
   */
  selectTab(tabId: number, staticTab: boolean = true) {
    if (this.staticTabs && this.staticTabs.length) {
      if (staticTab) {
        this.staticTabs.first.tabs[tabId].active = true;
      } else {
        this.staticTabs.last.tabs[tabId].active = true;
      }
    }
  }

  set updateDataTable(data: UpdateTable) {
    if (data.type === 'current') {
      this.task.tabla_datos = data.table;
    } else {
      this._dataTableAll = data.table;
    }
    if (this.runCondictionsDoc) {
      if (this.form.documento) {
        this.validCondictionsDocs();
      } else {
        this.docsValid = true;
      }
      if (this.form.radicado) {
        this.validRadicationsDocs();
      } else {
        this.radicateCompleted = true;
      }
    } else {
      this.runCondictionsDoc = true;
    }
  }

  set dataTableAll(table: TablaDatos[]) {
    this._dataTableAll = table;
  }

  get dataTableAll() {
    return this._dataTableAll;
  }

  /**
   * Guarda la informacion de la forma
   *
   * @param {InformacionGuardadaFormulario} dataSave
   * @memberof DynamicFormsComponent
   */
  formSave(dataSave: InformacionGuardadaFormulario) {
    this.savingForm = true;
    let asociar_documento = false;
    let asociar_expediente = false;
    let asociateOnEndingTask = false;
    let id_tramite = null;
    let consecutive_act = null;
    const dataSync: SincronizacionFormulario = {
      data: []
    };
    const taskSync: Array<number> = [];
    const saveMunicipality = this.getSaveMunicipality(dataSave.subForm, dataSave.data);
    const typeDocumentary = this.getDocumentary(dataSave.subForm, dataSave.data);
    if (this.associateTramite && dataSave.subForm.id_forma === this.idFormAssociation) {
      this.associationRadication(dataSave);
    }
    dataSave.subForm.campos.forEach(field => {
      let data: Datos;
      if (field.tipo_campo.nombre === 'coordenadas') {
        if (dataSave.data.hasOwnProperty(field.nombre_campo + '_latitud')) {
          const latitud = dataSave.data[field.nombre_campo + '_latitud'];
          const longitud = dataSave.data[field.nombre_campo + '_longitud'];
          const altura = dataSave.data[field.nombre_campo + '_altura'];
          const coodinate = {
            latitud: latitud ? latitud : '',
            longitud: longitud ? longitud : '',
            altura: altura ? altura : ''
          };
          data = {
            id: field.id,
            nombre_campo: field.nombre_campo,
            alias: field.alias,
            alias_formulario: dataSave.subForm.alias,
            nombre: field.label,
            valor: coodinate,
            tipo: field.tipo_campo.nombre,
          };
        }
      } else {
        data = this.searchDataForm(dataSave.data, field, '', dataSave.subForm.alias);
      }
      for (let index = 0; index < this.task.datos.length; index++) {
        if (this.task.datos[index].nombre_campo === field.nombre_campo) {
          this.task.datos.splice(index, 1);
          break;
        }
      }
      if (data) {
        this.task.datos.push(data);
        if (field.sincronizado) {
          const value: DatosSincronizacionFormulario = {
            valor: data.valor,
            alias: field.alias,
            campos: [],
          };
          if (data.valueSelects) {
            value.valueSelects = data.valueSelects;
          }

          if (this.formAssociationSync && this.formAssociationSync.length) {
            this.formAssociationSync.forEach(formAssociation => {
              if (formAssociation.id_tarea === this.task.id) {
                if (formAssociation.forma && formAssociation.forma.length) {
                  formAssociation.forma.forEach(form => {
                    if (!form.tabla && form.campos && form.campos.length) {
                      const existField = find(form.campos, { alias: field.alias });
                      if (existField && existField.tipo_campo.nombre === field.tipo_campo.nombre) {
                        const indexDatos = findIndex(this.task.datos, { id: existField.id });
                        if (indexDatos !== -1) {
                          this.task.datos[indexDatos].valor = data.valor;
                          if (data.valueSelects) {
                            this.task.datos[indexDatos].valueSelects = data.valueSelects;
                            if (existField.tipo_campo.nombre === 'ngSelect') {
                              if (existField.propiedades['condicion'] || field.propiedades['condicion']) {
                                this.task.datos[indexDatos].id_opcion = data.id_opcion;
                              }
                            }
                          }
                        } else {
                          const newData: Datos = {
                            id: existField.id,
                            nombre_campo: existField.nombre_campo,
                            nombre: existField.label,
                            alias: existField.alias,
                            alias_formulario: form.alias,
                            valor: data.valor,
                            tipo: existField.tipo_campo.nombre,
                          };
                          if (existField.tipo_campo.nombre === 'date-time-picker') {
                            newData.clasificacion = existField.propiedades['tipo'];
                          } else if (existField.tipo_campo.nombre === 'ngSelect') {
                            newData.clasificacion = existField.propiedades['tipo'];
                            newData.condicion = existField.propiedades['condicion'] ? true : false;
                            if (existField.propiedades['condicion'] || field.propiedades['condicion']) {
                              newData.id_opcion = data.id_opcion;
                            }
                          }
                          this.task.datos.push(newData);
                        }
                      }
                    }
                  });
                }
              } else {
                if (formAssociation.forma && formAssociation.forma.length) {
                  formAssociation.forma.forEach(form => {
                    if (!form.tabla && form.campos && form.campos.length) {
                      const existField = find(form.campos, { alias: field.alias });
                      if (existField && existField.tipo_campo.nombre === field.tipo_campo.nombre) {
                        const v: CamposSincronizar = {
                          id_tarea: formAssociation.id_tarea,
                          id_campo: existField.id,
                          nombre_campo: existField.nombre_campo,
                          nombre: existField.label,
                          tipo: existField.tipo_campo.nombre,
                          alias_formulario: form.alias
                        };
                        if (existField.tipo_campo.nombre === 'date-time-picker') {
                          v.clasificacion = existField.propiedades['tipo'];
                        } else if (existField.tipo_campo.nombre === 'ngSelect') {
                          v.clasificacion = existField.propiedades['tipo'];
                          v.condicion = existField.propiedades['condicion'] ? true : false;
                          if (existField.propiedades['condicion'] || field.propiedades['condicion']) {
                            v.id_opcion = data.id_opcion;
                          }
                        }
                        value.campos.push(v);
                        const existTask = taskSync.indexOf(formAssociation.id_tarea);
                        if (existTask === -1) {
                          taskSync.push(formAssociation.id_tarea);
                        }
                      }
                    }
                  });
                }
              }
            });
          }
          dataSync.data.push(value);
        }
      }
      if (field.propiedades.tipo == 'Tramites') {
        if (field.propiedades.asociar_documentos !== undefined && field.propiedades.asociar_documentos) {
          asociar_documento = true;
        } else if (field.propiedades.asociar_expediente !== undefined && field.propiedades.asociar_expediente) {
          asociar_expediente = true;
          if (field.propiedades.asociarProcedimientoFinaizar) {
            asociateOnEndingTask = true;
          }
        }
        if (data.valueSelects) {
          id_tramite = data.valor
        }
      }
    });
    this.dfds.saveDatos(
      this.task.id,
      this.task.datos,
      this.task.tabla_datos,
      saveMunicipality,
      typeDocumentary,
      asociar_documento,
      asociar_expediente,
      id_tramite,
      asociateOnEndingTask
    ).subscribe(async data => {
      if (data) {
        if (this.radication && this.radication.length) {
          this.radication.map(el => {
            el.documents = [];
            el.loadingDocs();
          });
        }
        if (this.docs && this.docs.length) {
          this.docs.map(el => {
            el.source = [];
            el.loadingDocs();
          });
        }
        this.savingForm = false
        if (taskSync && taskSync.length) {
          this.dfds.syncFormTask({ tareas: taskSync, formulario: dataSync }).then(() => {
            this.taskUpdate(true);
          }).catch(err => {
            this.taskUpdate(true);
          });
        } else {
          this.taskUpdate(true);
        }
        if (asociar_expediente) {
          this.dfds.getTableData(this.task.id).then((res: any) => {
            if (res) {
              let changes = false;
              if (res.tabla_datos && res.tabla_datos.length) {
                res.tabla_datos.forEach((tbl: any) => {
                  let ftd = find(this.task.tabla_datos, { alias: tbl.alias });
                  if (!ftd) {
                    this.task.tabla_datos.push(tbl);
                    changes = true;
                  } else {
                    const index = this.task.tabla_datos.indexOf(ftd);
                    this.task.tabla_datos[index] = tbl;
                    changes = true;
                  }
                });
                /* this.task.tabla_datos = res.tabla_datos;
                 changes = true;*/
                if (changes) {
                  this.taskUpdate(true);
                  this.eventsSubjectTable.next({ tabla_datos: this.task.tabla_datos, form: this.form });
                }
              }
            }
          }).catch(err => {
          })

          this.dfds.getTask(this.task.id).then(res => {
            if (res) {
              let changesFormNew = false;
              let datosFormularioNew: any[] = [];
              res.datos.forEach(r => {
                this.form.sub_formas.forEach(sub => {
                  if (sub.alias == r.alias_formulario) {
                    if (datosFormularioNew.length) {
                      let formularioActual = datosFormularioNew.find(df => df.alias_formulario == sub.alias)
                      if (formularioActual) {
                        formularioActual.datos[r.nombre_campo] = r.valor;
                      } else {
                        let dataNoExiste = {}
                        dataNoExiste[r.nombre_campo] = r.valor
                        datosFormularioNew.push({ alias_formulario: r.alias_formulario, datos: dataNoExiste });
                      }
                    } else {
                      let dataNoExiste = {}
                      dataNoExiste[r.nombre_campo] = r.valor
                      datosFormularioNew.push({ alias_formulario: r.alias_formulario, datos: dataNoExiste });
                    }
                  }
                })
                let ftd = find(this.task.datos, { alias: r.alias, alias_formulario: r.alias_formulario });
                if (!ftd) {
                  this.task.datos.push(r);
                  changesFormNew = true;
                } else {
                  const index = this.task.datos.indexOf(ftd);
                  this.task.datos[index] = r;
                  changesFormNew = true;
                }
                /*if(!this.task.datos.includes(r)){
                  this.task.datos.push(r);
                  changesFormNew = true;
                }*/
              })
              /*this.task.datos = res.datos;
              changesFormNew = true;*/
              if (changesFormNew) {
                datosFormularioNew.forEach(datosF => {
                  let subformEmit = this.form.sub_formas.find(sb => sb.alias == datosF.alias_formulario);
                  if (subformEmit) {
                    subformEmit.datos = datosF.datos
                  }
                })
                this.eventsSubjectForm.next({ datos: datosFormularioNew, form: this.form })
              }
            }
          }).catch(err => {
          })
        }
      }
    }, err => this.savingForm = false);
  }

  /**
   * Retorna el objeto a enviar al guardar el formulario de la tabla para guardar o eliminar el municipio
   * para la jurisdiccion del tramite
   *
   * @param {SubForma} form
   * @param {*} data
   * @returns {*}
   * @memberof DynamicFormsComponent
   */
  getSaveMunicipality(form: SubForma, data: any): any {
    const fieldMunicipality = find(form.campos, field => {
      if (field.propiedades['guardar_municipio']) {
        return field;
      }
    });
    if (fieldMunicipality) {
      let saveMunicipality;
      if (fieldMunicipality.tipo_campo.nombre === 'ngSelect') {
        if (data[fieldMunicipality.nombre_campo]) {
          saveMunicipality = { id_registro: data[fieldMunicipality.nombre_campo] };
          if (fieldMunicipality.lista_maestra[0].nombre !== Const.NAME_MASTER_TABLE_MUNICIPALITY) {
            saveMunicipality['columna'] = fieldMunicipality.propiedades['guardar_municipio'] + ' ';
          }
        } else {
          saveMunicipality = { eliminar: true };
        }
      }
      return saveMunicipality;
    } else {
      return null;
    }
  }

  /**
   *Obtiene el tipo documental seleccionado
   *
   * @param {*} subform
   * @param {*} data
   * @memberof DynamicFormsComponent
   */
  getDocumentary(subform: SubForma, data: any) {
    const type_documentary = find(subform.campos, field => {
      if (field.propiedades['tipo'] == 'TipoDocumental') {
        return field;
      }
    });
    if (type_documentary) {
      let resultTypeDocumentary;
      if (type_documentary.tipo_campo.nombre === 'ngSelect') {
        if (data[type_documentary.nombre_campo]) {
          resultTypeDocumentary = data[type_documentary.nombre_campo];
          // if (fieldMunicipality.lista_maestra[0].nombre !== Const.NAME_MASTER_TABLE_MUNICIPALITY) {
          //   saveMunicipality['columna'] = fieldMunicipality.propiedades['guardar_municipio'] + ' ';
          // }
        }
        //  else {
        //   saveMunicipality = {eliminar: true};
        // }
      }
      return resultTypeDocumentary;
    } else {
      return null;
    }
  }

  /**
   * Consulta y actualiza un campo del formulrio dinamico
   * siempre consulta y retorna el valor pero es opcional actualizar la informacion por en valor encontrado
   *
   * @param {*} form
   * @param {Control} field
   * @param {string} [plus='']
   * @param {string} [aliasFormulario='']
   * @returns {Datos}
   * @memberof DynamicFormsComponent
   */
  searchDataForm(
    form: any,
    field: Control,
    plus: string = '',
    aliasFormulario: string = ''
  ): Datos {
    const valor = form[field.nombre_campo + plus];

    let data: Datos;

    if (field.tipo_campo.nombre === 'checkbox') {
      if (form.hasOwnProperty(field.nombre_campo + plus)) {
        data = {
          id: field.id,
          nombre_campo: field.nombre_campo + plus,
          alias_formulario: aliasFormulario,
          alias: field.alias + plus,
          nombre: field.label,
          valor: valor ? valor : false,
          tipo: field.tipo_campo.nombre,
        };
      }
    } else if (valor && field.tipo_campo.nombre === 'date-time-picker') {
      const date = new Date(valor);
      const valueDate = new Date(date.toLocaleString('en-CO'));
      data = {
        id: field.id,
        nombre_campo: field.nombre_campo + plus,
        alias_formulario: aliasFormulario,
        alias: field.alias + plus,
        nombre: field.label,
        valor: valueDate.toLocaleString('en-CO'),
        tipo: field.tipo_campo.nombre,
        clasificacion: field.propiedades['tipo'],
      };
    } else if (valor && field.tipo_campo.nombre === 'ngSelect') {
      let label = '';
      let idOptionCondiction = -1;
      if (field.propiedades['options']) {
        label = result(find(field.propiedades['options'], { value: valor }), 'key');
        if (field.propiedades['condicion']) {
          idOptionCondiction = result(find(field.propiedades['options'], { value: valor }), 'idOption');
        }
        if (!label) {
          label = valor;
        }
      } else {
        label = valor;
      }
      if (field.propiedades['tipo'] === 'ConsecutivosActas') {
        this.consecutivesActas[field.nombre_campo] = valor;
      }
      data = {
        id: field.id,
        nombre_campo: field.nombre_campo + plus,
        alias_formulario: aliasFormulario,
        alias: field.alias + plus,
        nombre: field.label,
        valor: valor,
        tipo: field.tipo_campo.nombre,
        clasificacion: field.propiedades['tipo'],
        valueSelects: label,
        condicion: field.propiedades['condicion'] ? true : false,
      };
      if (idOptionCondiction && idOptionCondiction !== -1) {
        data.id_opcion = idOptionCondiction;
      }
    } else if (field.tipo_campo.nombre === 'number') {
      data = {
        id: field.id,
        nombre_campo: field.nombre_campo + plus,
        alias_formulario: aliasFormulario,
        alias: field.alias + plus,
        nombre: field.label,
        valor: valor ? valor : valor !== undefined && valor === 0 ? valor : null,
        tipo: field.tipo_campo.nombre,
      };
    } else if (valor || form.hasOwnProperty(field.nombre_campo + plus)) {
      data = {
        id: field.id,
        nombre_campo: field.nombre_campo + plus,
        alias_formulario: aliasFormulario,
        alias: field.alias + plus,
        nombre: field.label,
        valor: valor ? valor : null,
        tipo: field.tipo_campo.nombre,
      };
    }
    return data;
  }

  /**
   * Actualiza la tarea con la informacion guardada
   *
   * @param {boolean} [changeTab=false]
   * @returns {*}
   * @memberof DynamicFormsComponent
   */
  taskUpdate(changeTab: boolean = false): any {
    this.ctx.task = this.task;
    this.updateTask(this.ctx.task);
    if (this.form.documento) {
      this.validCondictionsDocs();
    }
    if (this.form.radicado) {
      this.validRadicationsDocs();
    }
    this.validTask();
    if (changeTab) {
      this.nextTabForm();
    }
  }

  /**
   * Guarda la informacion de la tabla
   *
   * @param {*} table
   * @memberof DynamicFormsComponent
   */
  saveDataTable(table: SaveTables) {
    this.task.tabla_datos = table.tables;
    this.dfds.saveDatos(this.task.id, this.task.datos, this.task.tabla_datos, table.saveMunicipality).subscribe(_ => {
      if (this.radication && this.radication.length) {
        this.radication.map(el => {
          el.documents = [];
          el.loadingDocs();
        });
      }
      if (this.docs && this.docs.length) {
        this.docs.map(el => {
          el.source = [];
          el.loadingDocs();
        });
      }
      this.taskUpdate();
    });
  }

  /**
   * Controla el evento de la validacion de la informacion
   *
   * @param {boolean} valid
   * @memberof DynamicFormsComponent
   */
  validForm(valid: boolean) {
    this.formValid = valid;
    this.validTask();
    this.nextTabForm();
  }

  /**
   * Cambio a pestaña siguiente desdel formulario
   *
   * @private
   * @memberof DynamicFormsComponent
   */
  private nextTabForm() {
    if (this.formValid && !this.savingForm) {
      const tabIndex = findIndex(this.orderTabs, { pestana: 'formularios' });
      let tabRender = -1;
      if (this.staticTabs.length) {
        tabRender = findIndex(this.staticTabs.first.tabs, { active: true });
      }
      if (tabIndex !== -1 && !this.finishTask) {
        if (!this.orderTabs[tabIndex].complete) {
          setTimeout(() => {
            if (
              tabIndex < (this.orderTabs.length - 1) &&
              (
                tabRender !== -1 &&
                (tabIndex + 1) > tabRender
              ) &&
              !this.staticTabs.first.tabs[tabIndex + 1].disabled
            ) {
              this.orderTabs[tabIndex].complete = true;
              this.selectTab((tabIndex + 1), true);
              this.selectTab((tabIndex + 1), false);
            }
          });
        }
      }
    }
  }

  /**
   * Se ejecuta antes de finalizar la tarea
   *
   * @param {boolean} res
   * @memberof DynamicFormsComponent
   */
  async beforeFinishing(res: boolean) {
    if (res) {
      if (this.consecutivesActas && Object.keys(this.consecutivesActas).length) {
        const consecutives: number[] = [];
        let isConsecutiveCinco = environment.actasAUCTIFFCinco;
        Object.keys(this.consecutivesActas).forEach(key => {
          if (this.consecutivesActas[key]) {
            consecutives.push(this.consecutivesActas[key]);
          }
        });
        if (consecutives.length) {
          this.message = 'Registrando consecutivo de actas';
          this.loadAction = true;
          this.dfds.registerConsecutive(consecutives, this.task.id, isConsecutiveCinco).then(resp => {
            this.message = '';
            this.loadAction = false;
            this.finish(resp);
          }).catch(_ => {
            this.message = '';
            this.loadAction = false;
          });
        }
      } else {
        this.finish(res);
      }
    }
  }

  /**
   * Finalizar la tarea.
   *
   * @param {boolean} res
   * @memberof DynamicFormsComponent
   */
  finish(res: boolean) {
    if (res) {
      const selectedOptions: number[] = [];
      let e: TaskEvent;
      const data: ConfigFinishDefault = {
        tarea: this.task.id
      };
      if (this.associateTramite && this.idTramiteAsociar) {
        data.tramite_asociacion = this.idTramiteAsociar;
        if (this.documentAsociar) {
          data.document_asociacion = this.documentAsociar;
        }
      }
      if (this.task.tarea_condicion.length && this.task.tarea_forma[0].condicion) {
        // data.id_opcion = this._selectedOptions[0].opcion;
        if (this.task.datos && this.task.datos.length) {
          this.task.datos.forEach(field => {
            if (field.tipo === 'ngSelect' && field.condicion) {
              if (field.id_opcion) {
                const idOption = find(this.task.tarea_condicion, { id_opcion: field.id_opcion });
                if (idOption) {
                  selectedOptions.push(field.id_opcion);
                }
              }
            }
          });
        }
      }

      if (this.form.estilo['revisiones']) {
        const options = this.validapprovals();
        if (options.length) {
          options.forEach(opt => {
            selectedOptions.push(opt);
          });
        }
      }

      if (!this.task.tarea_forma[0].condicion || (selectedOptions.length === 1)) {
        data.id_opcion = selectedOptions[0];
      } else if (selectedOptions.length) {
        data.id_opciones = selectedOptions;
      }
      if (!this.autoSave) {
        e = {
          type: 'finish',
          data: data
        };
        this.event.emit(e);
        this.close();
      } else {
        data['task'] = this.task;
        e = {
          type: 'finishAutoSave',
          data: data
        };
        this.event.emit(e);
      }
    }
  }

  /**
   * Controla el evento de cerrar la ventana de documentos
   *
   * @param {boolean} res
   * @memberof DynamicFormsComponent
   */
  closeDocs(res: boolean) {
    if (res) {
      this.wimdowManagementDocs = false;
    }
    setTimeout(() => {
      this.scrollForm('headertask');
    }
    );
  }

  /**
   * Àbre la ventana de gestion de documentos
   *
   * @memberof DynamicFormsComponent
   */
  openManagementDocs() {
    this.wimdowManagementDocs = true;
    setTimeout(() => {
      this.scrollForm('tab-management-docs');
    }
    );
  }

  /**
   * Posiciona el scroll a la caja deseada
   *
   * @param {string} positionScroll
   * @memberof DynamicFormsComponent
   */
  scrollForm(positionScroll: string) {
    if (positionScroll) {
      this.sts.scrollTo({
        target: positionScroll
      } as ScrollToConfigOptions);
    }
  }

  /**
   * Actualizar informacion de la tarea respecto a los documentos
   *
   * @param {*} data
   * @returns {*}
   * @memberof DynamicFormsComponent
   */
  documentUpdate(data: Documento[]): any {
    data.forEach(newDoc => {
      // Copiando funciones del documento
      const functionD: FuncionDocumento[] = [];
      newDoc.funciones.forEach(fun => {
        functionD.push({
          funcion: fun.funcion,
          id_funcion: fun.id_funcion,
          obligatorio: fun.obligatorio
        });
      });
      // Copienado documentos detalle del documento
      const detailDocument: DocumentoDetalle[] = [];
      newDoc.documentos_detalle.forEach(detail => {
        // Copiando historial del docuemnto
        const record: HistorialDocumento[] = [];
        if (detail.historial && detail.historial.length) {
          detail.historial.forEach(history => {
            // Copiando revisiones del registro de historial del documento
            const revisions: RevisionDocumento[] = [];
            if (history.revision && history.revision.length) {
              history.revision.forEach(revision => {
                revisions.push({
                  id_revision: revision.id_revision,
                  id_tarea: revision.id_tarea,
                  reponsable_id: revision.reponsable_id,
                  nombre_tarea: revision.nombre_tarea,
                  descripcion: revision.descripcion,
                  nombre_responsable: revision.nombre_responsable,
                  apellidos_responsable: revision.apellidos_responsable,
                  fecha: revision.fecha,
                  revision: revision.revision,
                  historial_id: revision.historial_id,
                  version: revision.version,
                  opcion: revision.opcion
                });
              });
            }
            record.push({
              id: history.id,
              nombre: history.nombre,
              nombre_archivo: history.nombre_archivo,
              extension: history.extension,
              version: history.version,
              revision: revisions,
              radicado: history.radicado,
              tarea_origen: history.tarea_origen
            });
          });
        }
        detailDocument.push({
          fecha: detail.fecha,
          folios: detail.folios,
          historial: record,
          id_documento: detail.id_documento,
          radicado: detail.radicado,
          documento_cita: detail.documento_cita,
          id_documento_cita: detail.id_documento_cita,
          usuario: detail.usuario
        });
      });
      // Copiando documento
      const doc: Documento = {
        clasificacion: newDoc.clasificacion,
        clasificacion_id: newDoc.clasificacion_id,
        codigo_documento: newDoc.codigo_documento,
        documentos_detalle: detailDocument,
        funciones: functionD,
        id_tipo_documental: newDoc.id_tipo_documental,
        id_expediente_cita: newDoc.id_expediente_cita,
        ruta_generacion: newDoc.ruta_generacion,
        ruta_vista_previa: newDoc.ruta_vista_previa,
        tipo_documental: newDoc.tipo_documental,
      };
      this.ctx.task.documentos.forEach((document, index) => {
        if (this.task.id === newDoc.idtarea && document.clasificacion_id === newDoc.clasificacion_id) {
          this.ctx.task.documentos[index] = doc;
        }
      });
      if (this.ctx.task.tarea_asociacion && this.ctx.task.tarea_asociacion.length) {
        this.ctx.task.tarea_asociacion.forEach(taskAssociation => {
          taskAssociation.documentos.forEach((document, index) => {
            if (
              taskAssociation.id_tarea_destino === newDoc.idtarea &&
              document.clasificacion_id === newDoc.clasificacion_id
            ) {
              taskAssociation.documentos[index] = doc;
            }
          });
        });
      }
    });
    this.updateTask(this.ctx.task);
    if (this.radication && this.radication.length) {
      this.radication.map(el => {
        el.documents = [];
        el.loadingDocs();
      });
    }
    if (this.approveSign && this.approveSign.length) {
      this.approveSign.map(el => {
        el.source = [];
        el.loadingDocs();
      });
    }
    this.validCondictionsDocs();
  }

  /**
  * Actualizar informacion de los solicitantes para documentos
  *
  * @param {*} data
  * @returns {*}
  * @memberof DynamicFormsComponent
  */
  userMultiUpdate(data: SolicitanteControl[]): any {
    this.userMulti = data;
  }

  /**
   * Actualiza la tarea con la informacion o documentos retornados por el comonente de radicacion
   *
   * @param {Tarea} data
   * @memberof DynamicFormsComponent
   */
  documentUpdateRadication(data: Tarea) {
    this.ctx.task = data;
    this.updateTask(this.ctx.task);
    if (this.approveSign && this.approveSign.length) {
      this.approveSign.map(el => {
        el.source = [];
        el.loadingDocs();
      });
    }
    if (this.docs && this.docs.length) {
      this.docs.map(el => {
        el.source = [];
        el.loadingDocs();
      });
    }
    this.validTask();
  }

  /**
   *Actualiza la tarea con la información retornada del componente de radicación especial
   *
   * @param {Tarea} data
   * @memberof DynamicFormsComponent
   */
  updateTaskSpecialRadi(data: Tarea) {
    this.ctx.task = data;
    this.updateTask(this.ctx.task);
    this.validTask();
  }

  /**
   * Actualiza la tarea en el json del flujo
   *
   * @param {*} data
   * @returns {*}
   * @memberof DynamicFormsComponent
   */
  documentUpdateRevisions(data: Documento[]): any {
    for (let index = 0; index < this.ctx.task.tarea_asociacion.length; index++) {
      for (let indexDoc = 0; indexDoc < this.ctx.task.tarea_asociacion[index].documentos.length; indexDoc++) {
        const newDocument = find(
          data,
          { clasificacion_id: this.ctx.task.tarea_asociacion[index].documentos[indexDoc].clasificacion_id }
        );
        if (newDocument) {
          this.ctx.task.tarea_asociacion[index].documentos[indexDoc] = newDocument;
        }
      }
    }
    for (let index = 0; index < this.task.tarea_asociacion.length; index++) {
      for (let indexDoc = 0; indexDoc < this.task.tarea_asociacion[index].documentos.length; indexDoc++) {
        const newDocument = find(
          data,
          { clasificacion_id: this.task.tarea_asociacion[index].documentos[indexDoc].clasificacion_id }
        );
        if (newDocument) {
          this.task.tarea_asociacion[index].documentos[indexDoc] = newDocument;
        }
      }
    }
    this.updateTask(this.ctx.task);
    if (this.radication && this.radication.length) {
      this.radication.map(el => {
        el.documents = [];
        el.loadingDocs();
      });
    }
    if (this.docs && this.docs.length) {
      this.docs.map(el => {
        el.source = [];
        el.loadingDocs();
      });
    }
    this.validReview();
  }

  /**
   * Valida que todos los documentos se hayan subido y activa el boton de finalizar
   *
   * @memberof DynamicFormsComponent
   */
  validDocs(forcedValid: any = null) {
    let valid = true;
    let documents: Documento[] = Static.copyObjet(this.task.documentos);
    if (this.form.documento) {
      if (documents && documents.length > 0 && this.form.documento) {
        for (let indexDoc = 0; indexDoc < documents.length; indexDoc++) {
          if (
            this.form &&
            this.condictionsDoc[this.form.alias] &&
            this.condictionsDoc[this.form.alias][documents[indexDoc].clasificacion]
          ) {
            if (documents[indexDoc].funciones && documents[indexDoc].funciones.length) {
              const functions: FuncionDocumento[] = Static.copyObjet(documents[indexDoc].funciones);
              functions.forEach(funtion => {
                switch (funtion.funcion) {
                  case Const.DOCUMENTS_FUNCTIONS.upload:
                    this.validCondictionsDoc(
                      this.condictionsDoc[this.form.alias][documents[indexDoc].clasificacion]['condictionsDocs'],
                      documents[indexDoc],
                      funtion.funcion
                    );
                    break;
                  case Const.DOCUMENTS_FUNCTIONS.generate:
                    this.validCondictionsDoc(
                      this.condictionsDoc[this.form.alias][documents[indexDoc].clasificacion]['condictionsGenerate'],
                      documents[indexDoc],
                      funtion.funcion
                    );
                    break;
                }
              });
            }
          }
          let validUpload = false;
          if (documents[indexDoc].funciones.length > 0) {
            for (let indexFuntion = 0;
              indexFuntion < documents[indexDoc].funciones.length;
              indexFuntion++) {
              if (
                documents[indexDoc].funciones[indexFuntion].funcion === Const.DOCUMENTS_FUNCTIONS.upload ||
                documents[indexDoc].funciones[indexFuntion].funcion === Const.DOCUMENTS_FUNCTIONS.dowload
              ) {
                if (documents[indexDoc].funciones[indexFuntion].obligatorio) {
                  validUpload = true;
                  break;
                }
              }
            }
          }
          if (validUpload) {
            const docUpload = find(documents[indexDoc].funciones, { funcion: Const.DOCUMENTS_FUNCTIONS.upload });
            if (docUpload) {
              if (documents[indexDoc].documentos_detalle.length > 0) {
                if (documents[indexDoc].documentos_detalle[0].hasOwnProperty('historial')) {
                  if (documents[indexDoc].documentos_detalle[0].historial.length > 0) {
                    const versionDoc = documents[indexDoc].documentos_detalle[0].historial.length;
                    for (let indexHistory = 0;
                      indexHistory < documents[indexDoc].documentos_detalle[0].historial.length;
                      indexHistory++) {
                      if (documents[indexDoc]
                        .documentos_detalle[0].historial[indexHistory].version === versionDoc) {
                        if (documents[indexDoc]
                          .documentos_detalle[0].historial[indexHistory].revision.length) {
                          let idReview = 0;
                          for (let indexReview = 0;
                            indexReview < documents[indexDoc]
                              .documentos_detalle[0].historial[indexHistory].revision.length;
                            indexReview++) {
                            if (documents[indexDoc]
                              .documentos_detalle[0].historial[indexHistory]
                              .revision[indexReview].id_revision > idReview) {
                              idReview = documents[indexDoc]
                                .documentos_detalle[0].historial[indexHistory]
                                .revision[indexReview].id_revision;
                            }
                          }
                          for (let indexReview = 0;
                            indexReview < documents[indexDoc]
                              .documentos_detalle[0].historial[indexHistory].revision.length;
                            indexReview++) {
                            if (documents[indexDoc]
                              .documentos_detalle[0].historial[indexHistory]
                              .revision[indexReview].id_revision === idReview) {
                              if (!documents[indexDoc]
                                .documentos_detalle[0].historial[indexHistory]
                                .revision[indexReview].revision) {
                                valid = false;
                                break;
                              } else {
                                valid = true;
                              }
                            }
                          }
                          if (!valid) {
                            break;
                          }
                        } else {
                          const currentSourceDocuments = filter(
                            this.task.documentos[indexDoc].documentos_detalle[0].historial,
                            { tarea_origen: this.task.id }
                          );
                          if (currentSourceDocuments && currentSourceDocuments.length) {
                            valid = true;
                          } else {
                            valid = false;
                            break;
                          }
                        }
                      }
                    }
                  } else {
                    valid = false;
                    break;
                  }
                } else {
                  valid = false;
                  break;
                }
              } else {
                valid = false;
                break;
              }
            } else {
              if (documents[indexDoc].documentos_detalle.length > 0) {
                const doc = findIndex(
                  this.documentsDownload,
                  el => el === documents[indexDoc].documentos_detalle[0].id_documento
                );
                if (doc !== -1) {
                  valid = true;
                } else {
                  valid = false;
                  break;
                }
              } else if (this.documentsGenerated.length) {
                const doc = findIndex(
                  this.documentsGenerated,
                  {
                    idtarea: this.task.id,
                    clasificacion_id: documents[indexDoc].clasificacion_id
                  }
                );
                if (doc !== -1) {
                  valid = true;
                } else {
                  valid = false;
                  break;
                }
              } else {
                valid = false;
                break;
              }
            }
          }
          if (!valid) {
            break;
          }
        }
      }
      if (valid) {
        if (this.task.tarea_asociacion && this.task.tarea_asociacion.length) {
          for (const taskAssociation of this.task.tarea_asociacion) {
            documents = Static.copyObjet(taskAssociation.documentos);
            if (documents.length > 0) {
              for (let indexDoc = 0; indexDoc < documents.length; indexDoc++) {
                if (
                  this.condictionsDoc[taskAssociation.alias] &&
                  this.condictionsDoc[taskAssociation.alias][documents[indexDoc].clasificacion]
                ) {
                  if (documents[indexDoc].funciones && documents[indexDoc].funciones.length) {
                    const functions: FuncionDocumento[] = Static.copyObjet(documents[indexDoc].funciones);
                    functions.forEach(funtion => {
                      switch (funtion.funcion) {
                        case Const.DOCUMENTS_FUNCTIONS.upload:
                          this.validCondictionsDoc(
                            // tslint:disable-next-line:max-line-length
                            this.condictionsDoc[taskAssociation.alias][documents[indexDoc].clasificacion]['condictionsDocs'],
                            documents[indexDoc],
                            funtion.funcion
                          );
                          break;
                        case Const.DOCUMENTS_FUNCTIONS.generate:
                          this.validCondictionsDoc(
                            // tslint:disable-next-line:max-line-length
                            this.condictionsDoc[taskAssociation.alias][documents[indexDoc].clasificacion]['condictionsGenerate'],
                            documents[indexDoc],
                            funtion.funcion
                          );
                          break;
                      }
                    });
                  }
                }
                let validUpload = false;
                if (documents[indexDoc].funciones.length > 0) {
                  for (let indexFuntion = 0;
                    indexFuntion < documents[indexDoc].funciones.length;
                    indexFuntion++) {
                    if (
                      documents[indexDoc].funciones[indexFuntion].funcion === Const.DOCUMENTS_FUNCTIONS.upload ||
                      documents[indexDoc].funciones[indexFuntion].funcion === Const.DOCUMENTS_FUNCTIONS.dowload
                    ) {
                      if (documents[indexDoc].funciones[indexFuntion].obligatorio) {
                        validUpload = true;
                        break;
                      }
                    }
                  }
                }
                if (validUpload) {
                  const docUpload = find(documents[indexDoc].funciones, { funcion: Const.DOCUMENTS_FUNCTIONS.upload });
                  if (docUpload) {
                    if (documents[indexDoc].documentos_detalle.length > 0) {
                      if (documents[indexDoc].documentos_detalle[0].hasOwnProperty('historial')) {
                        if (documents[indexDoc].documentos_detalle[0].historial.length > 0) {
                          const versionDoc = documents[indexDoc].documentos_detalle[0].historial.length;
                          for (let indexHistory = 0;
                            indexHistory < documents[indexDoc].documentos_detalle[0].historial.length;
                            indexHistory++) {
                            if (documents[indexDoc]
                              .documentos_detalle[0].historial[indexHistory].version === versionDoc) {
                              if (documents[indexDoc]
                                .documentos_detalle[0].historial[indexHistory].revision.length) {
                                let idReview = 0;
                                for (let indexReview = 0;
                                  indexReview < documents[indexDoc]
                                    .documentos_detalle[0].historial[indexHistory].revision.length;
                                  indexReview++) {
                                  if (documents[indexDoc]
                                    .documentos_detalle[0].historial[indexHistory]
                                    .revision[indexReview].id_revision > idReview) {
                                    idReview = documents[indexDoc]
                                      .documentos_detalle[0].historial[indexHistory]
                                      .revision[indexReview].id_revision;
                                  }
                                }
                                for (let indexReview = 0;
                                  indexReview < documents[indexDoc]
                                    .documentos_detalle[0].historial[indexHistory].revision.length;
                                  indexReview++) {
                                  if (documents[indexDoc]
                                    .documentos_detalle[0].historial[indexHistory]
                                    .revision[indexReview].id_revision === idReview) {
                                    if (!documents[indexDoc]
                                      .documentos_detalle[0].historial[indexHistory]
                                      .revision[indexReview].revision) {
                                      valid = false;
                                      break;
                                    } else {
                                      valid = true;
                                    }
                                  }
                                }
                                if (!valid) {
                                  break;
                                }
                              } else {
                                const currentSourceDocuments = filter(
                                  taskAssociation.documentos[indexDoc].documentos_detalle[0].historial,
                                  { tarea_origen: this.task.id }
                                );
                                if (currentSourceDocuments && currentSourceDocuments.length) {
                                  valid = true;
                                } else {
                                  valid = false;
                                  break;
                                }
                              }
                            }
                          }
                        } else {
                          valid = false;
                          break;
                        }
                      } else {
                        valid = false;
                        break;
                      }
                    } else {
                      valid = false;
                      break;
                    }
                  } else {
                    if (documents[indexDoc].documentos_detalle.length > 0) {
                      const doc = findIndex(
                        this.documentsDownload,
                        el => el === documents[indexDoc].documentos_detalle[0].id_documento
                      );
                      if (doc !== -1) {
                        valid = true;
                      } else {
                        valid = false;
                        break;
                      }
                    } else if (this.documentsGenerated.length) {
                      const doc = findIndex(
                        this.documentsGenerated,
                        {
                          idtarea: taskAssociation.id_tarea_destino,
                          clasificacion_id: documents[indexDoc].clasificacion_id
                        }
                      );
                      if (doc !== -1) {
                        valid = true;
                      } else {
                        valid = false;
                        break;
                      }
                    } else {
                      valid = false;
                      break;
                    }
                  }
                }
                if (!valid) {
                  break;
                }
              }
              if (!valid) {
                break;
              }
            }
          }
        }
      }
    }
    if (forcedValid != null) {
      if (forcedValid) {
        this.docsValid = true;
        const tabIndex = findIndex(this.orderTabs, { pestana: 'gestion_documentos' });
        let tabRender = -1;
        if (this.staticTabs.length) {
          tabRender = findIndex(this.staticTabs.first.tabs, { active: true });
        }
        if (tabIndex !== -1 && !this.finishTask) {
          if (!this.orderTabs[tabIndex].complete) {
            if (
              tabIndex < (this.orderTabs.length - 1) &&
              (
                tabRender !== -1 &&
                (tabIndex + 1) > tabRender
              ) &&
              !this.staticTabs.first.tabs[tabIndex + 1].disabled
            ) {
              this.orderTabs[tabIndex].complete = true;
              this.selectTab((tabIndex + 1), true);
              this.selectTab((tabIndex + 1), false);
            }
          }
        }
      } else {
        this.docsValid = false;
      }
    } else {
      if (valid) {
        this.docsValid = true;
        const tabIndex = findIndex(this.orderTabs, { pestana: 'gestion_documentos' });
        let tabRender = -1;
        if (this.staticTabs.length) {
          tabRender = findIndex(this.staticTabs.first.tabs, { active: true });
        }
        if (tabIndex !== -1 && !this.finishTask) {
          if (!this.orderTabs[tabIndex].complete) {
            if (
              tabIndex < (this.orderTabs.length - 1) &&
              (
                tabRender !== -1 &&
                (tabIndex + 1) > tabRender
              ) &&
              !this.staticTabs.first.tabs[tabIndex + 1].disabled
            ) {
              this.orderTabs[tabIndex].complete = true;
              this.selectTab((tabIndex + 1), true);
              this.selectTab((tabIndex + 1), false);
            }
          }
        }
      } else {
        this.docsValid = false;
      }
    }


    this.validTask();
  }

  /**
   * Valida que tanto el formulario como el componente de documentos este valido
   *
   * @memberof DynamicFormsComponent
   */
  validTask() {
    if (this.docsValid && this.formValid && this.radicateCompleted && this.revisionCompleted && this.specialradicateCompleted && this.responseOf && this.remissionFuntionaries && this.copyTo && this.sentBy) {
      if (this.isDisabledBtnFinish) {
        this.isDisabledBtnFinish = false;
        if (!(this.cdRef as ViewRef).destroyed) {
          this.cdRef.detectChanges();
        }
      }
    } else {
      if (!this.isDisabledBtnFinish) {
        this.isDisabledBtnFinish = true;
        if (!(this.cdRef as ViewRef).destroyed) {
          this.cdRef.detectChanges();
        }
      }
    }
    this.validViewtabs();
  }

  /**
   * Emula un refrescar para volver a cargar la informacion de la tabla y se cargue la ingresada por el documento
   *
   * @param {boolean} data
   * @memberof DynamicFormsComponent
   */
  refresh(data: boolean) {
    this.viewDynamicForm = data;
    if (data) {
      this.message = 'Cargando informacion';
    }
  }

  /**
   * Controla la respuesta de el com ponnete de radicacion para informar que ya estan completas las radicaciones
   *
   * @param {boolean} res
   * @memberof DynamicFormsComponent
   */
  completeRadication(res: boolean) {
    this.radicateCompleted = res;
    if (res) {
      setTimeout(() => {
        const tabIndex = findIndex(this.orderTabs, { pestana: 'radicacion' });
        let tabRender = -1;
        if (this.staticTabs.length) {
          tabRender = findIndex(this.staticTabs.first.tabs, { active: true });
        }
        if (tabIndex !== -1 && !this.finishTask) {
          if (!this.orderTabs[tabIndex].complete) {
            if (
              tabIndex < (this.orderTabs.length - 1) &&
              (
                tabRender !== -1 &&
                (tabIndex + 1) > tabRender
              ) &&
              !this.staticTabs.first.tabs[tabIndex + 1].disabled
            ) {
              this.orderTabs[tabIndex].complete = true;
              this.selectTab((tabIndex + 1), true);
              this.selectTab((tabIndex + 1), false);
            }
          }
        }
      });
    }
    this.validCondictionsDocs();
  }

  /**
   * Ejecuta la sincronizacion de los formularios y tablas
   *
   * @param {DatosSincronizacion} dataSyncTable
   * @memberof DynamicFormsComponent
   */
  async eventSyncDataTable(dataSyncTable: DatosSincronizacion) {
    await this.dfds.syncFormTask(dataSyncTable);
  }

  /**
   * Validad inicialmente que los documentos por radicar ya esten radicados
   *
   * @private
   * @returns {*}
   * @memberof DynamicFormsComponent
   */
  private validRadication(): any {
    const documents: Documento[] = [];
    const task: Tarea = Static.copyObjet(this.task);
    let val = false;
    if (task.documentos.length) {
      task.documentos.forEach(doc => {
        const copyDoc = Static.copyObjet(doc);
        copyDoc.idtarea = task.id;
        documents.push(copyDoc);
      });
    }
    if (task.tarea_asociacion) {
      task.tarea_asociacion.forEach(association => {
        if (association.documentos) {
          association.documentos.forEach(document => {
            if (document.funciones) {
              document.funciones.forEach(functionDocument => {
                if (functionDocument.funcion) {
                  if (functionDocument.funcion === Const.DOCUMENTS_FUNCTIONS.radication) {
                    const copyDoc = Static.copyObjet(document);
                    copyDoc.idtarea = association.id_tarea_destino;
                    documents.push(copyDoc);
                  }
                }
              });
            }
          });
        }
      });
    }
    if (documents && documents.length) {
      for (const doc of documents) {
        if (doc.idtarea === this.task.id) {
          if (
            this.form &&
            this.condictionsDoc[this.form.alias] &&
            this.condictionsDoc[this.form.alias][doc.clasificacion]
          ) {
            if (doc.funciones && doc.funciones.length) {
              const functions: FuncionDocumento[] = Static.copyObjet(doc.funciones);
              functions.forEach(funtion => {
                if (funtion.funcion === Const.DOCUMENTS_FUNCTIONS.radication) {
                  this.validCondictionsDoc(
                    this.condictionsDoc[this.form.alias][doc.clasificacion]['condictionsRadicate'],
                    doc,
                    funtion.funcion
                  );
                }
              });
            }
          }
        } else {
          if (this.task.tarea_asociacion && this.task.tarea_asociacion.length) {
            const taskAssociation = find(this.task.tarea_asociacion, { id_tarea_destino: doc.idtarea });
            if (
              taskAssociation &&
              this.condictionsDoc[taskAssociation.alias] &&
              this.condictionsDoc[taskAssociation.alias][doc.clasificacion]
            ) {
              if (doc.funciones && doc.funciones.length) {
                const functions: FuncionDocumento[] = Static.copyObjet(doc.funciones);
                functions.forEach(funtion => {
                  if (funtion.funcion === Const.DOCUMENTS_FUNCTIONS.radication) {
                    this.validCondictionsDoc(
                      this.condictionsDoc[taskAssociation.alias][doc.clasificacion]['condictionsRadicate'],
                      doc,
                      funtion.funcion
                    );
                  }
                });
              }
            }
          }
        }
        const funcion = find(doc.funciones, { funcion: Const.DOCUMENTS_FUNCTIONS.radication });
        if (funcion) {
          if (funcion.obligatorio) {
            if (doc.documentos_detalle.length) {
              if (doc.documentos_detalle[0].radicado) {
                if (doc.expediente) {
                  val = true;
                } else {
                  if (!doc.documentos_detalle[0].documento_cita) {
                    if (doc.documentos_detalle[0].historial.length) {
                      const historyDoc = find(doc.documentos_detalle[0].historial, { radicado: true });
                      if (historyDoc) {
                        val = true;
                      } else {
                        val = false;
                        break;
                      }
                    } else {
                      val = false;
                      break;
                    }
                  } else {
                    val = true;
                  }
                }
              } else {
                val = false;
                break;
              }
            } else {
              val = false;
              break;
            }
          } else {
            val = true;
          }
        } else {
          val = true;
        }
      }
    }
    this.radicateCompleted = val;
    this.validTask();
  }

  /**
   * Validad que la tarea se pueda finalizar
   *
   * @memberof DynamicFormsComponent
   */
  finishConfirm() {
    if (!this.isDisabledBtnFinish && this.userResponsible && !this.finishTask && !this.secondaryActive) {
      this.confirmFinish.open();
    } else {
      if (!this.userResponsible) {
        this.toastr.error('Usted no posee los permisos suficientes para ejecutar esta acción.', 'Permiso denegado');
      } else if (this.finishTask) {
        this.toastr.error('La tarea ya está finalizada.', 'Acción no permitida');
      } else if (this.secondaryActive) {
        this.toastr.error(
          'No se puede realizar esta acción debido a que se encuentra un procesos secundario en progreso.',
          'Acción no permitida'
        );
      } else if (this.isDisabledBtnFinish) {
        this.toastr.error('Por Favor ingrese toda la información requerida.', 'Información incompleta');
      } else {
        this.toastr.error(
          'Lo sentimos ha ocurrido un error inesperado, inténtalo de nuevo más tarde.',
          'Error inesperado'
        );
      }
    }
  }

  /**
   * Validacion de las condiciones de los documentos para la funcion de gestion de documentos (subir)
   *
   * @private
   * @memberof DynamicFormsComponent
   */
  private validCondictionsDocs() {
    let valid = true;
    if (this.condictionsDocs && this.condictionsDocs.length) {
      let valView = false;
      let valHide = false;
      let firstView = true;
      let firstHide = true;
      let operactorNext = 'O';
      this.condictionsDocs.forEach(condiction => {
        let date = false;
        let comply = false;
        let value: Datos = null;
        let formulario: SubForma;
        let control: Control;
        let valor: any;
        const moment = require('moment');
        if (!Number(condiction.valor) || condiction.fechaActual) {
          if (condiction.fechaActual) {
            condiction.valor = new Date();
            date = true;
          } else if (condiction.valor && moment(new Date(String(condiction.valor))).isValid()) {
            date = true;
          } else {
            date = false;
          }
        } else {
          date = false;
        }
        if (this.form.alias === condiction.forma) {
          formulario = find(this.form.sub_formas, { alias: condiction.formulario });
          if (formulario) {
            control = find(formulario.campos, { alias: condiction.campo });
            if (!formulario.tabla) {
              if (control) {
                if (this.task.datos && this.task.datos.length) {
                  value = find(this.task.datos, { nombre_campo: control.nombre_campo });
                }
              }
            } else {
              valor = [];
              const table = find(
                this.task.tabla_datos as TablaDatos[],
                (t: TablaDatos) => t.alias === condiction.formulario
              );
              if (table && table.valores && table.valores.length) {
                table.valores.forEach((row: any) => {
                  if (row[table.labels[control.alias]]) {
                    valor.push(row[table.labels[control.alias]]);
                  }
                });
              }
            }
          }
        } else {
          if (this.task.tarea_asociacion && this.task.tarea_asociacion.length) {
            const tasAssociation = find(this.task.tarea_asociacion, { alias: condiction.forma });
            if (tasAssociation) {
              if (tasAssociation.datos && tasAssociation.datos.length) {
                value = find(tasAssociation.datos, { alias_formulario: condiction.formulario, alias: condiction.campo });
              }
              if (!value) {
                if (this.dataTableAll.length) {
                  const table = find(this.dataTableAll, { alias: condiction.formulario });
                  if (table) {
                    valor = [];
                    table.valores.forEach((row: any) => {
                      if (row[table.labels[condiction.campo]]) {
                        valor.push(row[table.labels[condiction.campo]]);
                      }
                    });
                  }
                }
              }
            }
          }
        }
        if (value) {
          valor = value.valor;
        }
        if (typeof valor === 'undefined') {
          valor = '';
        }
        switch (condiction.siEs) {
          case 'Vacio':
            if (
              !valor ||
              valor === ''
            ) {
              comply = true;
            } else {
              comply = false;
            }
            break;
          case 'Diferente':
            if (!date) {
              if (String(valor).toLowerCase() !== String(condiction.valor).toLowerCase()) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                let valorCondiction: string = null;
                let valorControl: string = null;
                const dtValor: Date = new Date(condiction.valor);
                switch (value.clasificacion) {
                  case 'calendar':
                    valorCondiction = dtValor.toLocaleDateString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      valorControl = dtValorControl.toLocaleDateString();
                    }
                    break;
                  case 'timer':
                    dtValor.setSeconds(0, 0);
                    valorCondiction = dtValor.toLocaleTimeString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                      valorControl = dtValorControl.toLocaleTimeString();
                    }
                    break;
                  default:
                    dtValor.setSeconds(0, 0);
                    valorCondiction = dtValor.toLocaleDateString();
                    valorCondiction += ' ' + dtValor.toLocaleTimeString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                      valorControl = dtValorControl.toLocaleDateString();
                      valorControl += ' ' + dtValorControl.toLocaleTimeString();
                    }
                    break;
                }
                if (valorControl !== valorCondiction) {
                  comply = true;
                } else {
                  comply = false;
                }
              } else {
                dtValorControl = new Date(valor);
                // tslint:disable-next-line:max-line-length
                if (moment(dtValorControl).isValid() && dtValorControl.toLocaleDateString() !== new Date(condiction.valor).toLocaleDateString()) {
                  comply = true;
                } else {
                  comply = false;
                }
              }
            }
            break;
          case 'Mayor a':
            if (!date) {
              if (Number(valor) > Number(condiction.valor)) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              let valorCondiction: Date = null;
              valorCondiction = new Date(condiction.valor);
              dtValorControl = new Date(valor);
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                switch (value.clasificacion) {
                  case 'calendar':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setHours(0, 0, 0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setHours(0, 0, 0, 0);
                    }
                    break;
                  case 'timer':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setDate(new Date().getDate());
                      dtValorControl.setMonth(new Date().getMonth());
                      dtValorControl.setFullYear(new Date().getFullYear());
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setDate(new Date().getDate());
                      valorCondiction.setMonth(new Date().getMonth());
                      valorCondiction.setFullYear(new Date().getFullYear());
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                  default:
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                }
              } else {
                if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                  dtValorControl.setHours(0, 0, 0, 0);
                }
                if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                  valorCondiction.setHours(0, 0, 0, 0);
                }
              }
              // Operacion
              if (
                (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                dtValorControl > valorCondiction
              ) {
                comply = true;
              } else {
                comply = false;
              }
            }
            break;
          case 'Mayor o igual a':
            if (!date) {
              if (Number(valor) >= Number(condiction.valor)) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              let valorCondiction: Date = null;
              valorCondiction = new Date(condiction.valor);
              dtValorControl = new Date(valor);
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                switch (value.clasificacion) {
                  case 'calendar':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setHours(0, 0, 0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setHours(0, 0, 0, 0);
                    }
                    break;
                  case 'timer':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setDate(new Date().getDate());
                      dtValorControl.setMonth(new Date().getMonth());
                      dtValorControl.setFullYear(new Date().getFullYear());
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setDate(new Date().getDate());
                      valorCondiction.setMonth(new Date().getMonth());
                      valorCondiction.setFullYear(new Date().getFullYear());
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                  default:
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                }
              } else {
                if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                  dtValorControl.setHours(0, 0, 0, 0);
                }
                if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                  valorCondiction.setHours(0, 0, 0, 0);
                }
              }
              // Operacion
              if (
                (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                dtValorControl >= valorCondiction
              ) {
                comply = true;
              } else {
                comply = false;
              }
            }
            break;
          case 'Menor a':
            if (!date) {
              if (Number(valor) < Number(condiction.valor)) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              let valorCondiction: Date = null;
              valorCondiction = new Date(condiction.valor);
              dtValorControl = new Date(valor);
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                switch (value.clasificacion) {
                  case 'calendar':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setHours(0, 0, 0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setHours(0, 0, 0, 0);
                    }
                    break;
                  case 'timer':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setDate(new Date().getDate());
                      dtValorControl.setMonth(new Date().getMonth());
                      dtValorControl.setFullYear(new Date().getFullYear());
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setDate(new Date().getDate());
                      valorCondiction.setMonth(new Date().getMonth());
                      valorCondiction.setFullYear(new Date().getFullYear());
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                  default:
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                }
              } else {
                if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                  dtValorControl.setHours(0, 0, 0, 0);
                }
                if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                  valorCondiction.setHours(0, 0, 0, 0);
                }
              }
              // Operacion
              if (
                (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                dtValorControl < valorCondiction
              ) {
                comply = true;
              } else {
                comply = false;
              }
            }
            break;
          case 'Menor o igual a':
            if (!date) {
              if (Number(valor) <= Number(condiction.valor)) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              let valorCondiction: Date = null;
              valorCondiction = new Date(condiction.valor);
              dtValorControl = new Date(valor);
              if (value && value.tipo === 'date-time-picker') {
                switch (value.clasificacion) {
                  case 'calendar':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setHours(0, 0, 0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setHours(0, 0, 0, 0);
                    }
                    break;
                  case 'timer':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setDate(new Date().getDate());
                      dtValorControl.setMonth(new Date().getMonth());
                      dtValorControl.setFullYear(new Date().getFullYear());
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setDate(new Date().getDate());
                      valorCondiction.setMonth(new Date().getMonth());
                      valorCondiction.setFullYear(new Date().getFullYear());
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                  default:
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                }
              } else {
                if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                  dtValorControl.setHours(0, 0, 0, 0);
                }
                if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                  valorCondiction.setHours(0, 0, 0, 0);
                }
              }
              // Operacion
              if (
                (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                dtValorControl <= valorCondiction
              ) {
                comply = true;
              } else {
                comply = false;
              }
            }
            break;
          case 'Se encuentra en los registros':
            if (!date) {
              const indexExist = valor.indexOf(condiction.valor);
              if (indexExist !== -1) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              const dates = this.calculateDateList(condiction, valor, value);
              let exist: Date;
              if (dates.valueControl && dates.valueControl.length) {
                exist = find(dates.valueControl, d => {
                  if (
                    (d instanceof Date && moment(d).isValid()) &&
                    (dates.valueCondiction instanceof Date && moment(dates.valueCondiction).isValid()) &&
                    // tslint:disable-next-line: max-line-length
                    d.toLocaleDateString() + ' - ' + d.toLocaleTimeString() === dates.valueCondiction.toLocaleDateString() + ' - ' + dates.valueCondiction.toLocaleTimeString()
                  ) {
                    return d;
                  }
                });
                if (exist) {
                  comply = true;
                } else {
                  comply = false;
                }
              } else {
                comply = false;
              }
            }
            break;
          case 'No se encuentra en los registros':
            if (!date) {
              const indexExist = valor.indexOf(condiction.valor);
              if (indexExist === -1) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              const dates = this.calculateDateList(condiction, valor, value);
              let exist: Date;
              if (dates.valueControl && dates.valueControl.length) {
                exist = find(dates.valueControl, d => {
                  if (
                    (d instanceof Date && moment(d).isValid()) &&
                    (dates.valueCondiction instanceof Date && moment(dates.valueCondiction).isValid()) &&
                    // tslint:disable-next-line: max-line-length
                    d.toLocaleDateString() + ' - ' + d.toLocaleTimeString() === dates.valueCondiction.toLocaleDateString() + ' - ' + dates.valueCondiction.toLocaleTimeString()
                  ) {
                    return d;
                  }
                });
                if (!exist) {
                  comply = true;
                } else {
                  comply = false;
                }
              } else {
                comply = false;
              }
            }
            break;
          default:
            if (!date) {
              if (String(valor).toLowerCase() === String(condiction.valor).toLowerCase()) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                let valorCondiction: string = null;
                let valorControl: string = null;
                const dtValor: Date = new Date(condiction.valor);
                switch (value.clasificacion) {
                  case 'calendar':
                    valorCondiction = dtValor.toLocaleDateString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      valorControl = dtValorControl.toLocaleDateString();
                    }
                    break;
                  case 'timer':
                    dtValor.setSeconds(0, 0);
                    valorCondiction = dtValor.toLocaleTimeString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                      valorControl = dtValorControl.toLocaleTimeString();
                    }
                    break;
                  default:
                    dtValor.setSeconds(0, 0);
                    valorCondiction = dtValor.toLocaleDateString();
                    valorCondiction += ' ' + dtValor.toLocaleTimeString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                      valorControl = dtValorControl.toLocaleDateString();
                      valorControl += ' ' + dtValorControl.toLocaleTimeString();
                    }
                    break;
                }
                if (valorControl === valorCondiction) {
                  comply = true;
                } else {
                  comply = false;
                }
              } else {
                dtValorControl = new Date(valor);
                // tslint:disable-next-line:max-line-length
                if (moment(dtValorControl).isValid() && dtValorControl.toLocaleDateString() === new Date(condiction.valor).toLocaleDateString()) {
                  comply = true;
                } else {
                  comply = false;
                }
              }
            }
            break;
        }
        switch (condiction.accion) {
          case 'Mostrar':
            if (!firstView) {
              if (!operactorNext || operactorNext === 'O') {
                if (valView || comply) {
                  valView = true;
                } else {
                  valView = false;
                }
              } else {
                if (valView && comply) {
                  valView = true;
                } else {
                  valView = false;
                }
              }
            } else {
              firstView = false;
              firstHide = true;
              valView = comply;
            }
            valHide = !valView;
            operactorNext = condiction.operadorCondicion;
            break;
          case 'Ocultar':
            if (!firstHide) {
              if (!operactorNext || operactorNext === 'O') {
                if (valHide || comply) {
                  valHide = true;
                } else {
                  valHide = false;
                }
              } else {
                if (valHide && comply) {
                  valHide = true;
                } else {
                  valHide = false;
                }
              }
            } else {
              firstHide = false;
              firstView = true;
              valHide = comply;
            }
            valView = !valHide;
            operactorNext = condiction.operadorCondicion;
            break;
        }
      });
      if (valView || !valHide) {
        valid = true;
        this.tabDocs = this.form.documento;
      } else {
        valid = false;
        this.tabDocs = false;
      }
    } else {
      this.tabDocs = this.form.documento;
    }
    if (valid) {
      this.validDocs();
    } else {
      this.docsValid = true;
      this.validTask();
    }
  }

  /**
   * Calcula las fechas de la condicion y el valor por el cual se condicionara
   * estas fechas toman el formato indicado por el tipo
   *
   * @private
   * @param {CondicionDocumento} condiction
   * @param {any[]} valor
   * @param {Datos} [value]
   * @returns {DatesCondiction}
   * @memberof DynamicFormsComponent
   */
  private calculateDateList(condiction: CondicionDocumento, valor: any[], value?: Datos): DatesCondiction {
    const dtValorControl: Date[] = [];
    let valorCondiction: Date = null;
    const moment = require('moment');
    valorCondiction = new Date(condiction.valor);
    if (valor && valor.length) {
      valor.forEach(v => {
        dtValorControl.push(new Date(v));
      });
    }
    if (value && value.tipo === 'date-time-picker') {
      switch (value.clasificacion) {
        case 'calendar':
          if (dtValorControl && dtValorControl.length) {
            dtValorControl.forEach(dt => {
              if (dt && dt instanceof Date && moment(dt).isValid()) {
                dt.setHours(0, 0, 0, 0);
              }
            });
          }
          if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
            valorCondiction.setHours(0, 0, 0, 0);
          }
          break;
        case 'timer':
          if (dtValorControl && dtValorControl.length) {
            dtValorControl.forEach(dt => {
              if (dt && dt instanceof Date && moment(dt).isValid()) {
                dt.setDate(new Date().getDate());
                dt.setMonth(new Date().getMonth());
                dt.setFullYear(new Date().getFullYear());
                dt.setSeconds(0, 0);
              }
            });
          }
          if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
            valorCondiction.setDate(new Date().getDate());
            valorCondiction.setMonth(new Date().getMonth());
            valorCondiction.setFullYear(new Date().getFullYear());
            valorCondiction.setSeconds(0, 0);
          }
          break;
        default:
          if (dtValorControl && dtValorControl.length) {
            dtValorControl.forEach(dt => {
              if (dt && dt instanceof Date && moment(dt).isValid()) {
                dt.setSeconds(0, 0);
              }
            });
          }
          if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
            valorCondiction.setSeconds(0, 0);
          }
          break;
      }
    } else {
      if (dtValorControl && dtValorControl.length) {
        dtValorControl.forEach(dt => {
          if (dt && dt instanceof Date && moment(dt).isValid()) {
            dt.setHours(0, 0, 0, 0);
          }
        });
      }
      if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
        valorCondiction.setHours(0, 0, 0, 0);
      }
    }
    return { valueCondiction: valorCondiction, valueControl: dtValorControl };
  }

  /**
   * Validacion de las condiciones de los documentos para la funcion de radicacion
   *
   * @private
   * @memberof DynamicFormsComponent
   */
  private validRadicationsDocs() {
    let valid = true;
    if (this.condictionsRadicate && this.condictionsRadicate.length) {
      let valView = false;
      let valHide = false;
      let firstView = true;
      let firstHide = true;
      let operactorNext = 'O';
      this.condictionsRadicate.forEach(condiction => {
        let date = false;
        let comply = false;
        let value: Datos = null;
        let formulario: SubForma;
        let control: Control;
        let valor: any;
        const moment = require('moment');
        if (!Number(condiction.valor) || condiction.fechaActual) {
          if (condiction.fechaActual) {
            condiction.valor = new Date();
            date = true;
          } else if (condiction.valor && moment(new Date(String(condiction.valor))).isValid()) {
            date = true;
          } else {
            date = false;
          }
        } else {
          date = false;
        }
        if (this.form.alias === condiction.forma) {
          formulario = find(this.form.sub_formas, { alias: condiction.formulario });
          if (formulario) {
            control = find(formulario.campos, { alias: condiction.campo });
            if (!formulario.tabla) {
              if (control) {
                if (this.task.datos && this.task.datos.length) {
                  value = find(this.task.datos, { nombre_campo: control.nombre_campo });
                }
              }
            } else {
              valor = [];
              const table = find(
                this.task.tabla_datos as TablaDatos[],
                (t: TablaDatos) => t.alias === condiction.formulario
              );
              if (table && table.valores && table.valores.length) {
                table.valores.forEach((row: any) => {
                  if (row[table.labels[control.alias]]) {
                    valor.push(row[table.labels[control.alias]]);
                  }
                });
              }
            }
          }
        } else {
          if (this.task.tarea_asociacion && this.task.tarea_asociacion.length) {
            const tasAssociation = find(this.task.tarea_asociacion, { alias: condiction.forma });
            if (tasAssociation) {
              if (tasAssociation.datos && tasAssociation.datos.length) {
                value = find(tasAssociation.datos, { alias_formulario: condiction.formulario, alias: condiction.campo });
              }
              if (!value) {
                if (this.dataTableAll.length) {
                  const table = find(this.dataTableAll, { alias: condiction.formulario });
                  if (table) {
                    valor = [];
                    table.valores.forEach((row: any) => {
                      if (row[table.labels[condiction.campo]]) {
                        valor.push(row[table.labels[condiction.campo]]);
                      }
                    });
                  }
                }
              }
            }
          }
        }
        if (value) {
          valor = value.valor;
        }
        if (typeof valor === 'undefined') {
          valor = '';
        }
        switch (condiction.siEs) {
          case 'Vacio':
            if (
              !valor ||
              valor === ''
            ) {
              comply = true;
            } else {
              comply = false;
            }
            break;
          case 'Diferente':
            if (!date) {
              if (String(valor).toLowerCase() !== String(condiction.valor).toLowerCase()) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                let valorCondiction: string = null;
                let valorControl: string = null;
                const dtValor: Date = new Date(condiction.valor);
                switch (value.clasificacion) {
                  case 'calendar':
                    valorCondiction = dtValor.toLocaleDateString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      valorControl = dtValorControl.toLocaleDateString();
                    }
                    break;
                  case 'timer':
                    dtValor.setSeconds(0, 0);
                    valorCondiction = dtValor.toLocaleTimeString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                      valorControl = dtValorControl.toLocaleTimeString();
                    }
                    break;
                  default:
                    dtValor.setSeconds(0, 0);
                    valorCondiction = dtValor.toLocaleDateString();
                    valorCondiction += ' ' + dtValor.toLocaleTimeString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                      valorControl = dtValorControl.toLocaleDateString();
                      valorControl += ' ' + dtValorControl.toLocaleTimeString();
                    }
                    break;
                }
                if (valorControl !== valorCondiction) {
                  comply = true;
                } else {
                  comply = false;
                }
              } else {
                dtValorControl = new Date(valor);
                // tslint:disable-next-line:max-line-length
                if (moment(dtValorControl).isValid() && dtValorControl.toLocaleDateString() !== new Date(condiction.valor).toLocaleDateString()) {
                  comply = true;
                } else {
                  comply = false;
                }
              }
            }
            break;
          case 'Mayor a':
            if (!date) {
              if (Number(valor) > Number(condiction.valor)) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              let valorCondiction: Date = null;
              valorCondiction = new Date(condiction.valor);
              dtValorControl = new Date(valor);
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                switch (value.clasificacion) {
                  case 'calendar':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setHours(0, 0, 0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setHours(0, 0, 0, 0);
                    }
                    break;
                  case 'timer':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setDate(new Date().getDate());
                      dtValorControl.setMonth(new Date().getMonth());
                      dtValorControl.setFullYear(new Date().getFullYear());
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setDate(new Date().getDate());
                      valorCondiction.setMonth(new Date().getMonth());
                      valorCondiction.setFullYear(new Date().getFullYear());
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                  default:
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                }
              } else {
                if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                  dtValorControl.setHours(0, 0, 0, 0);
                }
                if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                  valorCondiction.setHours(0, 0, 0, 0);
                }
              }
              // Operacion
              if (
                (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                dtValorControl > valorCondiction
              ) {
                comply = true;
              } else {
                comply = false;
              }
            }
            break;
          case 'Mayor o igual a':
            if (!date) {
              if (Number(valor) >= Number(condiction.valor)) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              let valorCondiction: Date = null;
              valorCondiction = new Date(condiction.valor);
              dtValorControl = new Date(valor);
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                switch (value.clasificacion) {
                  case 'calendar':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setHours(0, 0, 0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setHours(0, 0, 0, 0);
                    }
                    break;
                  case 'timer':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setDate(new Date().getDate());
                      dtValorControl.setMonth(new Date().getMonth());
                      dtValorControl.setFullYear(new Date().getFullYear());
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setDate(new Date().getDate());
                      valorCondiction.setMonth(new Date().getMonth());
                      valorCondiction.setFullYear(new Date().getFullYear());
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                  default:
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                }
              } else {
                if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                  dtValorControl.setHours(0, 0, 0, 0);
                }
                if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                  valorCondiction.setHours(0, 0, 0, 0);
                }
              }
              // Operacion
              if (
                (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                dtValorControl >= valorCondiction
              ) {
                comply = true;
              } else {
                comply = false;
              }
            }
            break;
          case 'Menor a':
            if (!date) {
              if (Number(valor) < Number(condiction.valor)) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              let valorCondiction: Date = null;
              valorCondiction = new Date(condiction.valor);
              dtValorControl = new Date(valor);
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                switch (value.clasificacion) {
                  case 'calendar':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setHours(0, 0, 0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setHours(0, 0, 0, 0);
                    }
                    break;
                  case 'timer':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setDate(new Date().getDate());
                      dtValorControl.setMonth(new Date().getMonth());
                      dtValorControl.setFullYear(new Date().getFullYear());
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setDate(new Date().getDate());
                      valorCondiction.setMonth(new Date().getMonth());
                      valorCondiction.setFullYear(new Date().getFullYear());
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                  default:
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                }
              } else {
                if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                  dtValorControl.setHours(0, 0, 0, 0);
                }
                if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                  valorCondiction.setHours(0, 0, 0, 0);
                }
              }
              // Operacion
              if (
                (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                dtValorControl < valorCondiction
              ) {
                comply = true;
              } else {
                comply = false;
              }
            }
            break;
          case 'Menor o igual a':
            if (!date) {
              if (Number(valor) <= Number(condiction.valor)) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              let valorCondiction: Date = null;
              valorCondiction = new Date(condiction.valor);
              dtValorControl = new Date(valor);
              if (value && value.tipo === 'date-time-picker') {
                switch (value.clasificacion) {
                  case 'calendar':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setHours(0, 0, 0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setHours(0, 0, 0, 0);
                    }
                    break;
                  case 'timer':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setDate(new Date().getDate());
                      dtValorControl.setMonth(new Date().getMonth());
                      dtValorControl.setFullYear(new Date().getFullYear());
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setDate(new Date().getDate());
                      valorCondiction.setMonth(new Date().getMonth());
                      valorCondiction.setFullYear(new Date().getFullYear());
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                  default:
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                }
              } else {
                if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                  dtValorControl.setHours(0, 0, 0, 0);
                }
                if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                  valorCondiction.setHours(0, 0, 0, 0);
                }
              }
              // Operacion
              if (
                (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                dtValorControl <= valorCondiction
              ) {
                comply = true;
              } else {
                comply = false;
              }
            }
            break;
          case 'Se encuentra en los registros':
            if (!date) {
              const indexExist = valor.indexOf(condiction.valor);
              if (indexExist !== -1) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              const dates = this.calculateDateList(condiction, valor, value);
              let exist: Date;
              if (dates.valueControl && dates.valueControl.length) {
                exist = find(dates.valueControl, d => {
                  if (
                    (d instanceof Date && moment(d).isValid()) &&
                    (dates.valueCondiction instanceof Date && moment(dates.valueCondiction).isValid()) &&
                    // tslint:disable-next-line: max-line-length
                    d.toLocaleDateString() + ' - ' + d.toLocaleTimeString() === dates.valueCondiction.toLocaleDateString() + ' - ' + dates.valueCondiction.toLocaleTimeString()
                  ) {
                    return d;
                  }
                });
                if (exist) {
                  comply = true;
                } else {
                  comply = false;
                }
              } else {
                comply = false;
              }
            }
            break;
          case 'No se encuentra en los registros':
            if (!date) {
              const indexExist = valor.indexOf(condiction.valor);
              if (indexExist === -1) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              const dates = this.calculateDateList(condiction, valor, value);
              let exist: Date;
              if (dates.valueControl && dates.valueControl.length) {
                exist = find(dates.valueControl, d => {
                  if (
                    (d instanceof Date && moment(d).isValid()) &&
                    (dates.valueCondiction instanceof Date && moment(dates.valueCondiction).isValid()) &&
                    // tslint:disable-next-line: max-line-length
                    d.toLocaleDateString() + ' - ' + d.toLocaleTimeString() === dates.valueCondiction.toLocaleDateString() + ' - ' + dates.valueCondiction.toLocaleTimeString()
                  ) {
                    return d;
                  }
                });
                if (!exist) {
                  comply = true;
                } else {
                  comply = false;
                }
              } else {
                comply = false;
              }
            }
            break;
          default:
            if (!date) {
              if (String(valor).toLowerCase() === String(condiction.valor).toLowerCase()) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                let valorCondiction: string = null;
                let valorControl: string = null;
                const dtValor: Date = new Date(condiction.valor);
                switch (value.clasificacion) {
                  case 'calendar':
                    valorCondiction = dtValor.toLocaleDateString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      valorControl = dtValorControl.toLocaleDateString();
                    }
                    break;
                  case 'timer':
                    dtValor.setSeconds(0, 0);
                    valorCondiction = dtValor.toLocaleTimeString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                      valorControl = dtValorControl.toLocaleTimeString();
                    }
                    break;
                  default:
                    dtValor.setSeconds(0, 0);
                    valorCondiction = dtValor.toLocaleDateString();
                    valorCondiction += ' ' + dtValor.toLocaleTimeString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                      valorControl = dtValorControl.toLocaleDateString();
                      valorControl += ' ' + dtValorControl.toLocaleTimeString();
                    }
                    break;
                }
                if (valorControl === valorCondiction) {
                  comply = true;
                } else {
                  comply = false;
                }
              } else {
                dtValorControl = new Date(valor);
                // tslint:disable-next-line:max-line-length
                if (moment(dtValorControl).isValid() && dtValorControl.toLocaleDateString() === new Date(condiction.valor).toLocaleDateString()) {
                  comply = true;
                } else {
                  comply = false;
                }
              }
            }
            break;
        }
        switch (condiction.accion) {
          case 'Mostrar':
            if (!firstView) {
              if (!operactorNext || operactorNext === 'O') {
                if (valView || comply) {
                  valView = true;
                } else {
                  valView = false;
                }
              } else {
                if (valView && comply) {
                  valView = true;
                } else {
                  valView = false;
                }
              }
            } else {
              firstView = false;
              firstHide = true;
              valView = comply;
            }
            valHide = !valView;
            operactorNext = condiction.operadorCondicion;
            break;
          case 'Ocultar':
            if (!firstHide) {
              if (!operactorNext || operactorNext === 'O') {
                if (valHide || comply) {
                  valHide = true;
                } else {
                  valHide = false;
                }
              } else {
                if (valHide && comply) {
                  valHide = true;
                } else {
                  valHide = false;
                }
              }
            } else {
              firstHide = false;
              firstView = true;
              valHide = comply;
            }
            valView = !valHide;
            operactorNext = condiction.operadorCondicion;
            break;
        }
      });
      if (valView || !valHide) {
        valid = true;
        this.tabRadicate = this.form.radicado;
      } else {
        valid = false;
        this.tabRadicate = false;
      }
    } else {
      this.tabRadicate = this.form.radicado;
    }
    if (valid) {
      this.validRadication();
    } else {
      this.radicateCompleted = true;
      this.validTask();
    }
  }

  /**
   * Validacion de las condiciones de un documento para la funcion de Subir y generar
   *
   * @private
   * @param {Array<CondicionDocumento>} condictions - condiciones de la funcion del documento
   * @param {Documento} document - documento
   * @param {string} [funcion='Subir'] - funcion a validar
   * @memberof DynamicFormsComponent
   */
  private validCondictionsDoc(
    condictions: Array<CondicionDocumento>,
    document: Documento,
    funcion: string = 'Subir'
  ) {
    let valid = true;
    if (condictions && condictions.length) {
      let valView = false;
      let valHide = false;
      let firstView = true;
      let firstHide = true;
      let operactorNext = 'O';
      condictions.forEach(condiction => {
        let date = false;
        let comply = false;
        let value: Datos = null;
        let formulario: SubForma;
        let control: Control;
        let valor: any;
        const moment = require('moment');
        if (!Number(condiction.valor) || condiction.fechaActual) {
          if (condiction.fechaActual) {
            condiction.valor = new Date();
            date = true;
          } else if (condiction.valor && moment(new Date(String(condiction.valor))).isValid()) {
            date = true;
          } else {
            date = false;
          }
        } else {
          date = false;
        }
        if (this.form && this.form.alias === condiction.forma) {
          formulario = find(this.form.sub_formas, { alias: condiction.formulario });
          if (formulario) {
            control = find(formulario.campos, { alias: condiction.campo });
            if (!formulario.tabla) {
              if (control) {
                if (this.task.datos && this.task.datos.length) {
                  value = find(this.task.datos, { nombre_campo: control.nombre_campo });
                }
              }
            } else {
              valor = [];
              const table = find(
                this.task.tabla_datos as TablaDatos[],
                (t: TablaDatos) => t.alias === condiction.formulario
              );
              if (table && table.valores && table.valores.length) {
                table.valores.forEach((row: any) => {
                  if (row[table.labels[control.alias]]) {
                    valor.push(row[table.labels[control.alias]]);
                  }
                });
              }
            }
          }
        } else {
          if (this.task.tarea_asociacion && this.task.tarea_asociacion.length) {
            const tasAssociation = find(this.task.tarea_asociacion, { alias: condiction.forma });
            if (tasAssociation) {
              if (tasAssociation.datos && tasAssociation.datos.length) {
                value = find(tasAssociation.datos, { alias_formulario: condiction.formulario, alias: condiction.campo });
              }
              if (!value) {
                if (this.dataTableAll.length) {
                  const table = find(this.dataTableAll, { alias: condiction.formulario });
                  if (table) {
                    valor = [];
                    table.valores.forEach((row: any) => {
                      if (row[table.labels[condiction.campo]]) {
                        valor.push(row[table.labels[condiction.campo]]);
                      }
                    });
                  }
                }
              }
            }
          }
        }
        if (value) {
          valor = value.valor;
        }
        switch (condiction.siEs) {
          case 'Vacio':
            if (
              !valor ||
              valor === ''
            ) {
              comply = true;
            } else {
              comply = false;
            }
            break;
          case 'Diferente':
            if (!date) {
              if (String(valor).toLowerCase() !== String(condiction.valor).toLowerCase()) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                let valorCondiction: string = null;
                let valorControl: string = null;
                const dtValor: Date = new Date(condiction.valor);
                switch (value.clasificacion) {
                  case 'calendar':
                    valorCondiction = dtValor.toLocaleDateString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      valorControl = dtValorControl.toLocaleDateString();
                    }
                    break;
                  case 'timer':
                    dtValor.setSeconds(0, 0);
                    valorCondiction = dtValor.toLocaleTimeString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                      valorControl = dtValorControl.toLocaleTimeString();
                    }
                    break;
                  default:
                    dtValor.setSeconds(0, 0);
                    valorCondiction = dtValor.toLocaleDateString();
                    valorCondiction += ' ' + dtValor.toLocaleTimeString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                      valorControl = dtValorControl.toLocaleDateString();
                      valorControl += ' ' + dtValorControl.toLocaleTimeString();
                    }
                    break;
                }
                if (valorControl !== valorCondiction) {
                  comply = true;
                } else {
                  comply = false;
                }
              } else {
                dtValorControl = new Date(valor);
                // tslint:disable-next-line:max-line-length
                if (moment(dtValorControl).isValid() && dtValorControl.toLocaleDateString() !== new Date(condiction.valor).toLocaleDateString()) {
                  comply = true;
                } else {
                  comply = false;
                }
              }
            }
            break;
          case 'Mayor a':
            if (!date) {
              if (Number(valor) > Number(condiction.valor)) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              let valorCondiction: Date = null;
              valorCondiction = new Date(condiction.valor);
              dtValorControl = new Date(valor);
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                switch (value.clasificacion) {
                  case 'calendar':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setHours(0, 0, 0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setHours(0, 0, 0, 0);
                    }
                    break;
                  case 'timer':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setDate(new Date().getDate());
                      dtValorControl.setMonth(new Date().getMonth());
                      dtValorControl.setFullYear(new Date().getFullYear());
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setDate(new Date().getDate());
                      valorCondiction.setMonth(new Date().getMonth());
                      valorCondiction.setFullYear(new Date().getFullYear());
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                  default:
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                }
              } else {
                if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                  dtValorControl.setHours(0, 0, 0, 0);
                }
                if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                  valorCondiction.setHours(0, 0, 0, 0);
                }
              }
              // Operacion
              if (
                (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                dtValorControl > valorCondiction
              ) {
                comply = true;
              } else {
                comply = false;
              }
            }
            break;
          case 'Mayor o igual a':
            if (!date) {
              if (Number(valor) >= Number(condiction.valor)) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              let valorCondiction: Date = null;
              valorCondiction = new Date(condiction.valor);
              dtValorControl = new Date(valor);
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                switch (value.clasificacion) {
                  case 'calendar':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setHours(0, 0, 0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setHours(0, 0, 0, 0);
                    }
                    break;
                  case 'timer':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setDate(new Date().getDate());
                      dtValorControl.setMonth(new Date().getMonth());
                      dtValorControl.setFullYear(new Date().getFullYear());
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setDate(new Date().getDate());
                      valorCondiction.setMonth(new Date().getMonth());
                      valorCondiction.setFullYear(new Date().getFullYear());
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                  default:
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                }
              } else {
                if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                  dtValorControl.setHours(0, 0, 0, 0);
                }
                if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                  valorCondiction.setHours(0, 0, 0, 0);
                }
              }
              // Operacion
              if (
                (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                dtValorControl >= valorCondiction
              ) {
                comply = true;
              } else {
                comply = false;
              }
            }
            break;
          case 'Menor a':
            if (!date) {
              if (Number(valor) < Number(condiction.valor)) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              let valorCondiction: Date = null;
              valorCondiction = new Date(condiction.valor);
              dtValorControl = new Date(valor);
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                switch (value.clasificacion) {
                  case 'calendar':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setHours(0, 0, 0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setHours(0, 0, 0, 0);
                    }
                    break;
                  case 'timer':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setDate(new Date().getDate());
                      dtValorControl.setMonth(new Date().getMonth());
                      dtValorControl.setFullYear(new Date().getFullYear());
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setDate(new Date().getDate());
                      valorCondiction.setMonth(new Date().getMonth());
                      valorCondiction.setFullYear(new Date().getFullYear());
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                  default:
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                }
              } else {
                if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                  dtValorControl.setHours(0, 0, 0, 0);
                }
                if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                  valorCondiction.setHours(0, 0, 0, 0);
                }
              }
              // Operacion
              if (
                (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                dtValorControl < valorCondiction
              ) {
                comply = true;
              } else {
                comply = false;
              }
            }
            break;
          case 'Menor o igual a':
            if (!date) {
              if (Number(valor) <= Number(condiction.valor)) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              let valorCondiction: Date = null;
              valorCondiction = new Date(condiction.valor);
              dtValorControl = new Date(valor);
              if (value && value.tipo === 'date-time-picker') {
                switch (value.clasificacion) {
                  case 'calendar':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setHours(0, 0, 0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setHours(0, 0, 0, 0);
                    }
                    break;
                  case 'timer':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setDate(new Date().getDate());
                      dtValorControl.setMonth(new Date().getMonth());
                      dtValorControl.setFullYear(new Date().getFullYear());
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setDate(new Date().getDate());
                      valorCondiction.setMonth(new Date().getMonth());
                      valorCondiction.setFullYear(new Date().getFullYear());
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                  default:
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                }
              } else {
                if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                  dtValorControl.setHours(0, 0, 0, 0);
                }
                if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                  valorCondiction.setHours(0, 0, 0, 0);
                }
              }
              // Operacion
              if (
                (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                dtValorControl <= valorCondiction
              ) {
                comply = true;
              } else {
                comply = false;
              }
            }
            break;
          case 'Se encuentra en los registros':
            if (!date) {
              const indexExist = valor.indexOf(condiction.valor);
              if (indexExist !== -1) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              const dates = this.calculateDateList(condiction, valor, value);
              let exist: Date;
              if (dates.valueControl && dates.valueControl.length) {
                exist = find(dates.valueControl, d => {
                  if (
                    (d instanceof Date && moment(d).isValid()) &&
                    (dates.valueCondiction instanceof Date && moment(dates.valueCondiction).isValid()) &&
                    // tslint:disable-next-line: max-line-length
                    d.toLocaleDateString() + ' - ' + d.toLocaleTimeString() === dates.valueCondiction.toLocaleDateString() + ' - ' + dates.valueCondiction.toLocaleTimeString()
                  ) {
                    return d;
                  }
                });
                if (exist) {
                  comply = true;
                } else {
                  comply = false;
                }
              } else {
                comply = false;
              }
            }
            break;
          case 'No se encuentra en los registros':
            if (!date) {
              const indexExist = valor.indexOf(condiction.valor);
              if (indexExist === -1) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              const dates = this.calculateDateList(condiction, valor, value);
              let exist: Date;
              if (dates.valueControl && dates.valueControl.length) {
                exist = find(dates.valueControl, d => {
                  if (
                    (d instanceof Date && moment(d).isValid()) &&
                    (dates.valueCondiction instanceof Date && moment(dates.valueCondiction).isValid()) &&
                    // tslint:disable-next-line: max-line-length
                    d.toLocaleDateString() + ' - ' + d.toLocaleTimeString() === dates.valueCondiction.toLocaleDateString() + ' - ' + dates.valueCondiction.toLocaleTimeString()
                  ) {
                    return d;
                  }
                });
                if (!exist) {
                  comply = true;
                } else {
                  comply = false;
                }
              } else {
                comply = false;
              }
            }
            break;
          default:
            if (!date) {
              if (String(valor).toLowerCase() === String(condiction.valor).toLowerCase()) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                let valorCondiction: string = null;
                let valorControl: string = null;
                const dtValor: Date = new Date(condiction.valor);
                switch (value.clasificacion) {
                  case 'calendar':
                    valorCondiction = dtValor.toLocaleDateString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      valorControl = dtValorControl.toLocaleDateString();
                    }
                    break;
                  case 'timer':
                    dtValor.setSeconds(0, 0);
                    valorCondiction = dtValor.toLocaleTimeString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                      valorControl = dtValorControl.toLocaleTimeString();
                    }
                    break;
                  default:
                    dtValor.setSeconds(0, 0);
                    valorCondiction = dtValor.toLocaleDateString();
                    valorCondiction += ' ' + dtValor.toLocaleTimeString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                      valorControl = dtValorControl.toLocaleDateString();
                      valorControl += ' ' + dtValorControl.toLocaleTimeString();
                    }
                    break;
                }
                if (valorControl === valorCondiction) {
                  comply = true;
                } else {
                  comply = false;
                }
              } else {
                dtValorControl = new Date(valor);
                // tslint:disable-next-line:max-line-length
                if (moment(dtValorControl).isValid() && dtValorControl.toLocaleDateString() === new Date(condiction.valor).toLocaleDateString()) {
                  comply = true;
                } else {
                  comply = false;
                }
              }
            }
            break;
        }
        switch (condiction.accion) {
          case 'Mostrar':
            if (!firstView) {
              if (!operactorNext || operactorNext === 'O') {
                if (valView || comply) {
                  valView = true;
                } else {
                  valView = false;
                }
              } else {
                if (valView && comply) {
                  valView = true;
                } else {
                  valView = false;
                }
              }
            } else {
              firstView = false;
              firstHide = true;
              valView = comply;
            }
            valHide = !valView;
            operactorNext = condiction.operadorCondicion;
            break;
          case 'Ocultar':
            if (!firstHide) {
              if (!operactorNext || operactorNext === 'O') {
                if (valHide || comply) {
                  valHide = true;
                } else {
                  valHide = false;
                }
              } else {
                if (valHide && comply) {
                  valHide = true;
                } else {
                  valHide = false;
                }
              }
            } else {
              firstHide = false;
              firstView = true;
              valHide = comply;
            }
            valView = !valHide;
            operactorNext = condiction.operadorCondicion;
            break;
        }
      });
      if (valView || !valHide) {
        valid = true;
      } else {
        valid = false;
      }
    }
    if (!valid) {
      if (document.funciones && document.funciones.length) {
        const indexfunction = findIndex(document.funciones, { funcion: funcion });
        if (indexfunction !== -1) {
          document.funciones.splice(indexfunction, 1);
        }
      }
    }
  }

  /**
   * Validar si desde la forma se asociara un radicado
   *
   * @private
   * @memberof DynamicFormsComponent
   */
  private validAssociationRadication() {
    const subFormAssociation = find(
      this.form.sub_formas,
      subForm => {
        const fieldAssociation = find(
          subForm.campos,
          field => {
            if (
              field.tipo_campo.nombre === 'ngSelect' &&
              field.propiedades['tipo'] === 'RadicadosSistema'
            ) {
              return field;
            }
          }
        );
        if (fieldAssociation) {
          return subForm;
        }
      }
    );
    if (subFormAssociation) {
      const fieldAssociationRadication = find(
        subFormAssociation.campos,
        field => {
          if (
            field.tipo_campo.nombre === 'ngSelect' &&
            field.propiedades['tipo'] === 'RadicadosSistema'
          ) {
            return field;
          }
        }
      );
      if (fieldAssociationRadication) {
        this.associateTramite = true;
        this.controlAssociation = fieldAssociationRadication;
        this.idFormAssociation = subFormAssociation.id_forma;
        if (this.task.datos && this.task.datos.length) {
          const dataForm = find(this.task.datos, { nombre_campo: this.controlAssociation.nombre_campo });
          if (dataForm) {
            this.idTramiteAsociar = dataForm.valor;
            this.documentAsociar = this.controlAssociation.propiedades ? this.controlAssociation.propiedades.asociar_documentos : false;
          }
        }
      }
    }
  }

  /**
   * Guarda temporalmente el tramite seleccionado
   *
   * @private
   * @param {InformacionGuardadaFormulario} dataSave
   * @memberof DynamicFormsComponent
   */
  private associationRadication(dataSave: InformacionGuardadaFormulario) {
    if (dataSave.data[this.controlAssociation.nombre_campo]) {
      this.idTramiteAsociar = dataSave.data[this.controlAssociation.nombre_campo];
      this.documentAsociar = this.controlAssociation.propiedades ? this.controlAssociation.propiedades.asociar_documentos : false;
    }
  }

  /**
   * Carga los consecutivos seleccionados en los formularios de la forma
   *
   * @private
   * @memberof DynamicFormsComponent
   */
  private loadConsecutives() {
    if (this.form && !this.finishTask) {
      this.form.sub_formas.forEach(subForm => {
        const fields = filter(subForm.campos, f => f.propiedades['tipo'] === 'ConsecutivosActas');
        if (fields && fields.length) {
          fields.forEach(field => {
            const campo = find(this.task.datos, { nombre_campo: field.nombre_campo });
            if (campo) {
              if (campo.valor) {
                this.consecutivesActas[campo.nombre_campo] = campo.valor;
              }
            }
          });
        }
      });
    }
  }

  /**
   * Valida las revisiones para activar el boton de finalizar
   *
   * @private
   * @memberof DynamicFormsComponent
   */
  private validReview() {
    let valid = false;
    const documents: Array<Documento> = [];
    this.task.tarea_asociacion.forEach(taskAssociation => {
      taskAssociation.documentos.forEach(document => {
        documents.push(document);
      });
    });
    for (let indexDocument = 0; indexDocument < documents.length; indexDocument++) {
      let required = false;
      documents[indexDocument].funciones.forEach(funcion => {
        if (
          funcion.funcion === Const.DOCUMENTS_FUNCTIONS.approve ||
          funcion.funcion === Const.DOCUMENTS_FUNCTIONS.sign
        ) {
          if (funcion.obligatorio) {
            required = true;
          }
        }
      });
      if (required) {
        for (let indexDetail = 0; indexDetail < documents[indexDocument].documentos_detalle.length; indexDetail++) {
          let indexMaxVersion = -1;
          let versionH = 0;
          for (
            let indexHistory = 0;
            indexHistory < documents[indexDocument].documentos_detalle[indexDetail].historial.length;
            indexHistory++
          ) {
            if (documents[indexDocument].documentos_detalle[indexDetail].historial[indexHistory].version > versionH) {
              versionH = documents[indexDocument].documentos_detalle[indexDetail].historial[indexHistory].version;
              indexMaxVersion = indexHistory;
            }
          }
          if (
            versionH &&
            documents[indexDocument].documentos_detalle[indexDetail].historial[indexMaxVersion].revision.length > 0
          ) {
            valid = true;
          } else {
            valid = false;
            break;
          }
          if (!valid) {
            break;
          }
        }
        if (!valid) {
          break;
        }
      } else {
        valid = true;
      }
    }
    this.revisionCompleted = valid;
    if (valid) {
      const tabIndex = findIndex(this.orderTabs, { pestana: 'revisiones' });
      let tabRender = -1;
      if (this.staticTabs.length) {
        tabRender = findIndex(this.staticTabs.first.tabs, { active: true });
      }
      if (tabIndex !== -1 && !this.finishTask) {
        if (!this.orderTabs[tabIndex].complete) {
          if (
            tabIndex < (this.orderTabs.length - 1) &&
            (
              tabRender !== -1 &&
              (tabIndex + 1) > tabRender
            ) &&
            !this.staticTabs.first.tabs[tabIndex + 1].disabled
          ) {
            this.orderTabs[tabIndex].complete = true;
            this.selectTab((tabIndex + 1), true);
            this.selectTab((tabIndex + 1), false);
          }
        }
      }
    }
    this.validTask();
  }

  /**
   *Revisa si ya se radicó en la radicación especial
   *
   * @memberof DynamicFormsComponent
   */
  validSpecial() {
    let valid = false;
    let complete = false;
    let required = false;
    this.orderTabs.forEach(ordt => {
      if (!ordt.requerido && ordt.pestana == 'radicacion_especial') {
        required = false;
      } else if (ordt.requerido && ordt.pestana == 'radicacion_especial') {
        required = true;
      }
    })
    if (required) {
      this.task.documentos.forEach(doc => {
        if (doc.documentos_detalle.length) {
          if (doc.documentos_detalle && doc.documentos_detalle.length) {
            doc.documentos_detalle.forEach(dd => {
              let checkFuction = find(doc.funciones, {
                funcion: Const.DOCUMENTS_FUNCTIONS.upload
              })
              if ((dd.historial && dd.historial.length) || ((checkFuction == undefined || checkFuction == null) && dd.radicado != undefined) || ((checkFuction != undefined || checkFuction != null) && dd.radicado != undefined && checkFuction.obligatorio == false)) {
                this.specialFinished = true;
                this.specialradicateCompleted = true;
              }
            });
          }
        }
      });
      if (this.specialFinished && this.specialradicateCompleted) {
        valid = true;
      }
    } else {
      valid = true;
      this.task.documentos.forEach(doc => {
        if (doc.documentos_detalle.length) {
          if (doc.documentos_detalle && doc.documentos_detalle.length) {
            doc.documentos_detalle.forEach(dd => {
              if (dd.historial) {
                this.specialFinished = true;
                this.specialradicateCompleted = true;
              }
            });
          }
        }
      });
    }
    if (valid) {
      const tabIndex = findIndex(this.orderTabs, { pestana: 'radicacion_especial' });
      let tabRender = -1;
      if (this.staticTabs.length) {
        tabRender = findIndex(this.staticTabs.first.tabs, { active: true });
      }
      if (tabIndex !== -1 && !this.finishTask) {
        if (!this.orderTabs[tabIndex].complete) {
          if (
            tabIndex < (this.orderTabs.length - 1) &&
            (
              tabRender !== -1 &&
              (tabIndex + 1) > tabRender
            )
          ) {
            this.orderTabs[tabIndex].complete = complete;
            this.validViewtabs();
            this.selectTab((tabIndex + 1), true);
            this.selectTab((tabIndex + 1), false);
          }
        }
      }
    }
    this.validTask();
  }

  /**
   *Valida la pestaña de respuesta de 
   *
   * @memberof DynamicFormsComponent
   */
  validResponse(valid: boolean = false) {
    let complete = false;
    if (valid) {
      this.finishedResponseOf = true;
    }
    if (!valid) {
      complete = false;
    } else { complete = true; }
    this.orderTabs.forEach(ordt => {
      if (!ordt.requerido && ordt.pestana == 'en_respuesta_de') {
        valid = true;
      }
    });
    this.responseOf = valid;
    if (valid) {
      const tabIndex = findIndex(this.orderTabs, { pestana: 'en_respuesta_de' });
      let tabRender = -1;
      if (this.staticTabs.length) {
        tabRender = findIndex(this.staticTabs.first.tabs, { active: true });
      }
      if (tabIndex !== -1 && !this.finishTask) {
        if (!this.orderTabs[tabIndex].complete) {
          if (this.staticTabs.first.tabs[tabIndex + 1] != undefined && !this.staticTabs.first.tabs[tabIndex + 1].disabled === false) {
            this.staticTabs.first.tabs[tabIndex + 1].disabled = false;
          }
          if (
            tabIndex < (this.orderTabs.length - 1) &&
            (
              tabRender !== -1 &&
              (tabIndex + 1) > tabRender
            ) &&
            !this.staticTabs.first.tabs[tabIndex + 1].disabled
          ) {
            this.orderTabs[tabIndex].complete = complete;
            this.selectTab((tabIndex + 1), true);
            this.selectTab((tabIndex + 1), false);
          }
        }
      }
    }
    this.validTask();
  }

  /**
   *Realiza las validaciones de la pestaña de remisión de funcionarios
   *
   * @memberof DynamicFormsComponent
   */
  validRemission(valid: boolean = false) {
    let complete = false;
    if (valid) {
      this.remissionFinished = true;
    }
    if (!valid) {
      complete = false;
      this.remissionFinished = false;
    } else { complete = true; }
    this.orderTabs.forEach(ordt => {
      if (!ordt.requerido && ordt.pestana == 'remision_funcionarios') {
        valid = true;
      }
    });
    this.remissionFuntionaries = valid;
    if (valid) {
      const tabIndex = findIndex(this.orderTabs, { pestana: 'remision_funcionarios' });
      let tabRender = -1;
      if (this.staticTabs.length) {
        tabRender = findIndex(this.staticTabs.first.tabs, { active: true });
      }
      if (tabIndex !== -1 && !this.finishTask) {
        if (!this.orderTabs[tabIndex].complete) {
          setTimeout(() => {
            if (
              tabIndex < (this.orderTabs.length - 1) &&
              (
                tabRender !== -1 &&
                (tabIndex + 1) > tabRender
              ) &&
              !this.staticTabs.first.tabs[tabIndex + 1].disabled
            ) {
              this.orderTabs[tabIndex].complete = complete;
              this.selectTab((tabIndex + 1), true);
              this.selectTab((tabIndex + 1), false);
            }
          })
        }
      }
    }
    this.validTask();
  }

  /**
   *Valida la pestaña de con copia a 
   *
   * @memberof DynamicFormsComponent
   */
  validCopy(valid: boolean = false) {
    let complete = false;
    if (valid) {
      this.copyToFinished = true;
    }
    if (!valid) {
      complete = false;
    } else { complete = true; }
    this.orderTabs.forEach(ordt => {
      if (!ordt.requerido && ordt.pestana == 'con_copia_a') {
        valid = true;
      }
    });
    this.copyTo = valid;
    if (valid) {
      const tabIndex = findIndex(this.orderTabs, { pestana: 'con_copia_a' });
      let tabRender = -1;
      if (this.staticTabs.length) {
        tabRender = findIndex(this.staticTabs.first.tabs, { active: true });
      }
      if (tabIndex !== -1 && !this.finishTask) {
        if (!this.orderTabs[tabIndex].complete) {
          if (
            tabIndex < (this.orderTabs.length - 1) &&
            (
              tabRender !== -1 &&
              (tabIndex + 1) > tabRender
            ) &&
            !this.staticTabs.first.tabs[tabIndex + 1].disabled
          ) {
            this.orderTabs[tabIndex].complete = complete;
            this.selectTab((tabIndex + 1), true);
            this.selectTab((tabIndex + 1), false);
          }
        }
      }
    }
    this.validTask();
  }

  /**
  *Valida la pestaña de enviado por 
  *
  * @memberof DynamicFormsComponent
  */
  validSentBy(valid: boolean = false) {
    let complete = false;
    if (valid) {
      this.sendedByFinished = true;
    }
    if (!valid) {
      complete = false;
    } else { complete = true; }
    this.orderTabs.forEach(ordt => {
      if (!ordt.requerido && ordt.pestana == 'enviado_por') {
        valid = true;
      }
    });
    this.sentBy = valid;
    if (valid) {
      const tabIndex = findIndex(this.orderTabs, { pestana: 'enviado_por' });
      let tabRender = -1;
      if (this.staticTabs.length) {
        tabRender = findIndex(this.staticTabs.first.tabs, { active: true });
      }
      if (tabIndex !== -1 && !this.finishTask) {
        if (!this.orderTabs[tabIndex].complete) {
          if (this.staticTabs.first.tabs[tabIndex + 1] != undefined && !this.staticTabs.first.tabs[tabIndex + 1].disabled === false) {
            this.staticTabs.first.tabs[tabIndex + 1].disabled = false;
          }
          if (
            tabIndex < (this.orderTabs.length - 1) &&
            (
              tabRender !== -1 &&
              (tabIndex + 1) > tabRender
            ) &&
            !this.staticTabs.first.tabs[tabIndex + 1].disabled
          ) {
            this.orderTabs[tabIndex].complete = complete;
            this.selectTab((tabIndex + 1), true);
            this.selectTab((tabIndex + 1), false);
          }
        }
      }
    }
    this.validTask();
  }


  /**
   * Valida las revisiones de los documentos si estan con accion positiva o hay almenos un documento con una
   * accion negativa y retorna el id de la opcion correspondiente
   *
   * @private
   * @returns {number}
   * @memberof DynamicFormsComponent
   */
  private validapprovals(): number[] {
    const disapprove = this.approvalsDocuments();
    if (!disapprove) {
      return this.getOptionsFinish(false);
    } else {
      return this.getOptionsFinish(true);
    }
  }

  /**
   * Indica si los documentos fueron aprobados
   *
   * @private
   * @returns {boolean}
   * @memberof DynamicFormsComponent
   */
  private approvalsDocuments(): boolean {
    let disapprove = 0;
    const documents: Array<Documento> = [];
    this.task.tarea_asociacion.forEach(taskAssociation => {
      taskAssociation.documentos.forEach(document => {
        documents.push(document);
      });
    });
    documents.forEach(document => {
      document.documentos_detalle.forEach(detail => {
        const version = detail.historial.length;
        detail.historial.forEach(history => {
          if (history.version === version) {
            let idReview = 0;
            history.revision.forEach(review => {
              if (review.id_revision > idReview) {
                idReview = review.id_revision;
              }
            });
            history.revision.forEach(review => {
              if (review.id_revision === idReview) {
                if (!review.revision) {
                  disapprove += 1;
                }
              }
            });
          }
        });
      });
    });
    if (disapprove > 0) {
      return false;
    } else {
      return true;
    }
  }

  /**
   * Retorna las opciones de finalizacion de la tarea
   * vasado en las opciones de revisiones seleccionadas
   * a los diferentes documentos de la tarea
   *
   * @private
   * @param {boolean} approve
   * @memberof DynamicFormsComponent
   */
  private getOptionsFinish(approve: boolean): number[] {
    const optionsFinish: number[] = [];
    const options = this.getOptionsSelect();
    if (options && options.length) {
      options.forEach(option => {
        let i = -1;
        if (approve) {
          i = this.idOptionAffirmative.indexOf(option);
        } else {
          i = this.idOptionNegative.indexOf(option);
        }
        if (i !== -1) {
          optionsFinish.push(option);
        }
      });
    }
    return optionsFinish;
  }

  /**
   * Retorna las opciones seleccionadas en las revisiones de los documentos
   *
   * @private
   * @memberof DynamicFormsComponent
   */
  private getOptionsSelect(): number[] {
    const options: number[] = [];
    const documents: Documento[] = [];
    this.task.tarea_asociacion.forEach(taskAssociation => {
      taskAssociation.documentos.forEach(document => {
        documents.push(document);
      });
    });
    documents.forEach(document => {
      document.documentos_detalle.forEach(detail => {
        if (detail.historial && detail.historial.length) {
          detail.historial.sort((a, b) => b.version - a.version);
          if (detail.historial[0].revision.length) {
            const i = options.indexOf(detail.historial[0].revision[0].opcion);
            if (i === -1) {
              options.push(detail.historial[0].revision[0].opcion);
            }
          }
        }
      });
    });
    return options;
  }

  /**
   * Define los id de las opciones de finalizacion
   *
   * @private
   * @memberof DynamicFormsComponent
   */
  private optionCondition() {
    (<TareaCondicion[]>this.task.tarea_condicion).forEach(condition => {
      if (condition.alias === this.form.estilo['revisiones']) {
        const existPositive = this.optionsPositive.indexOf(condition.opcion.toLowerCase());
        if (existPositive !== -1) {
          this.idOptionAffirmative.push(condition.id_opcion);
        } else {
          this.idOptionNegative.push(condition.id_opcion);
        }
      }
    });
  }

  /**
   * Indica el orden de las pestañas
   *
   * @private
   * @memberof DynamicFormsComponent
   */
  private setOrderTabs(validTabs: boolean = false) {
    if (this.form && this.form.estilo && this.form.estilo['orden_pestanas']) {
      this.orderTabs = this.form.estilo['orden_pestanas'];
      this.orderTabs.map((tab) => {
        tab.view = false;
      });
    }
    if (this.form && this.form.estilo && this.form.estilo['pestanas_modificables']) {
      this.form.estilo['pestanas_modificables'].forEach((pm: any) => {
        let tab = this.orderTabs.find(x => x.pestana == pm.pestana);
        if (tab) {
          tab.modificable = pm.modificable;
        }
      });
    }
    if (!this.form.estilo['revisiones']) {
      const indexRevisions = findIndex(this.orderTabs, { pestana: 'revisiones' });
      if (indexRevisions !== -1) {
        this.orderTabs.splice(indexRevisions, 1);
      }
    }
    if (!this.form.documento) {
      const indexDocs = findIndex(this.orderTabs, { pestana: 'gestion_documentos' });
      if (indexDocs !== -1) {
        this.orderTabs.splice(indexDocs, 1);
      }
    }
    if (!this.form.radicado) {
      const indexRadicate = findIndex(this.orderTabs, { pestana: 'radicacion' });
      if (indexRadicate !== -1) {
        this.orderTabs.splice(indexRadicate, 1);
      }
    }
    if (!this.form.estilo['anexos']) {
      const indexAttached = findIndex(this.orderTabs, { pestana: 'anexos' });
      if (indexAttached !== -1) {
        this.orderTabs.splice(indexAttached, 1);
      }
    }
    if (!this.form.estilo['special_radication']) {
      const indexAttached = findIndex(this.orderTabs, { pestana: 'radicacion_especial' });
      if (indexAttached !== -1) {
        this.orderTabs.splice(indexAttached, 1);
      }
    }
    if (!this.form.estilo['funcionarios']) {
      const indexAttached = findIndex(this.orderTabs, { pestana: 'con_copia_a' });
      if (indexAttached !== -1) {
        this.orderTabs.splice(indexAttached, 1);
      }
    }
    if (!this.form.estilo['enviado_por']) {
      const indexAttached = findIndex(this.orderTabs, { pestana: 'enviado_por' });
      if (indexAttached !== -1) {
        this.orderTabs.splice(indexAttached, 1);
      }
    }
    if (!this.form.estilo['remision']) {
      const indexAttached = findIndex(this.orderTabs, { pestana: 'remision_funcionarios' });
      if (indexAttached !== -1) {
        this.orderTabs.splice(indexAttached, 1);
      }
    }
    if (!this.form.estilo['en_respuesta_de']) {
      const indexAttached = findIndex(this.orderTabs, { pestana: 'en_respuesta_de' });
      if (indexAttached !== -1) {
        this.orderTabs.splice(indexAttached, 1);
      }
    }
    this.orderTabs.map((tab, i) => {
      tab.orden = i + 1;
    });
    this.loadAction = false;
    this.message = '';
  }

  /**
   * Validad el requerido de las pestañas y activa las pestañas
   *
   * @private
   * @memberof DynamicFormsComponent
   */
  private validViewtabs() {
    let indexRequired = -1;
    if (!this.finishTask) {
      for (let index = 0; index < this.orderTabs.length; index++) {
        if (this.orderTabs[index].requerido) {
          if (this.orderTabs[index].pestana === 'revisiones' && !this.revisionCompleted) {
            indexRequired = index;
          } else if (this.orderTabs[index].pestana === 'formularios' && !this.formValid) {
            indexRequired = index;
          } else if (this.orderTabs[index].pestana === 'gestion_documentos' && !this.docsValid) {
            indexRequired = index;
          } else if (this.orderTabs[index].pestana === 'radicacion' && !this.radicateCompleted) {
            indexRequired = index;
          }
          else if (this.orderTabs[index].pestana === 'en_respuesta_de' && !this.responseOf) {
            indexRequired = index;
          } else if (this.orderTabs[index].pestana === 'remision_funcionarios' && !this.remissionFuntionaries) {
            indexRequired = index;
          } else if (this.orderTabs[index].pestana === 'con_copia_a' && !this.copyTo) {
            indexRequired = index;
          } else if (this.orderTabs[index].pestana === 'enviado_por' && !this.sentBy) {
            indexRequired = index;
          } else if (this.orderTabs[index].pestana === 'radicacion_especial' && !this.specialradicateCompleted) {
            indexRequired = index;
          }
        }
        if (indexRequired !== -1) {
          break;
        }
      }
    }
    if (indexRequired !== -1) {
      let i = 0;
      while (i <= indexRequired) {
        if (!this.orderTabs[indexRequired].view) {
          this.orderTabs[i].view = true;
          if (!(this.cdRef as ViewRef).destroyed) {
            this.cdRef.detectChanges();
          }
        }
        i++;
      }
      indexRequired = indexRequired + 1;
      while (indexRequired < this.orderTabs.length) {
        if (this.orderTabs[indexRequired].view) {
          this.orderTabs[indexRequired].view = false;
          if (!(this.cdRef as ViewRef).destroyed) {
            this.cdRef.detectChanges();
          }
        }
        indexRequired = indexRequired + 1;
      }
    } else {
      this.orderTabs.map((tab) => {
        if (!tab.view) {
          tab.view = true;
          if (!(this.cdRef as ViewRef).destroyed) {
            this.cdRef.detectChanges();
          }
        }
      });
    }
  }

  /**
   *Valida si el usuario entró a la tarea a través del ícono Lápiz (modificar tarea de radicación)
   *Si sí, simplemente termina la acción de modificación para que se deshabiliten las opciones de guardar de los formularios
   * @memberof DynamicFormsComponent
   */
  validModify() {
    if (this.task.modificar) {
      this.task.modificar = false;
    }
  }

  OpenRejectHistoryTask() {
    const historys: HistoryAssignment[] = [];
    if (this.task.historial_rechazo && this.task.historial_rechazo.length) {
      this.task.historial_rechazo.forEach(history => {
        let responsibleAssignment = '';
        let responsiblerejection = '';
        let userAssignment = '';

        if (history.responsables && history.responsables.length) {
          history.responsables.forEach((responsible, index) => {
            if (index > 0) {
              responsibleAssignment += ' , ';
            }
            responsibleAssignment += responsible.nombres + ' ' + responsible.apellidos;
          });
        }

        if (history.usuarios_asignados && history.usuarios_asignados.length) {
          history.usuarios_asignados.forEach((userAssign, index) => {
            if (index > 0) {
              userAssignment += ' , ';
            }
            userAssignment += userAssign.nombres + ' ' + userAssign.apellidos;
          });
        }
        if (history.rechazo) {
          if (history.rechazo.responsable) {
            responsiblerejection += history.rechazo.responsable.nombres + ' ' + history.rechazo.responsable.apellidos;
          }
        }

        historys.push({
          fecha_finalizacion: new Date(history.fecha_finalizacion).toLocaleDateString(),
          responsable: responsibleAssignment,
          usuarios_asignados: userAssignment,
          fecha_rechazo: history.rechazo ? new Date(history.rechazo.fecha_rechazo).toLocaleDateString() : null,
          descripcion: history.rechazo ? history.rechazo.descripcion : null,
          responsable_rechazo: responsiblerejection,
        });

      });
    }

    this.sourceRejectHistory = new LocalDataSource(historys);
    this.sourceRejectHistory.refresh();

    this.modalRef = this.modalService.show(this.templateHistoryReject, { class: 'modal-lg-personalized' });
  }
}



// WEBPACK FOOTER //
// ./src/app/forms/all/dynamic-forms/dynamic-forms.component.ts